{
  "common": {
    "from": "desde {{price}}",
    "soon": "pronto",
    "online": "En línea",
    "back": "Atrás",
    "close": "Cerrar",
    "cancel": "Cancelar",
    "apply": "Aplicar",
    "retry": "Reintentar",
    "retryLater": "Inténtalo de nuevo un poco más tarde.",
    "loading": "Cargando…",
    "increase": "Más",
    "decrease": "Menos"
  },
  "categories": {
    "HOME": {
      "name": "Hogar",
      "short": "Limpieza, reparaciones, traslados"
    },
    "DOCS": {
      "name": "Documentos",
      "short": "Tarjeta social, traducción, residencia"
    },
    "LEARNING": {
      "name": "Formación y carrera",
      "short": "Idiomas y asesor de carrera"
    },
    "PERKS": {
      "name": "Descuentos y regalos",
      "short": "Cafeterías, restaurantes, regalos"
    }
  },
  "services": {
    "cleaning": {
      "name": "Limpieza",
      "description": "Normal, a fondo o tras una reforma. Personal verificado y reporte con fotos al terminar."
    },
    "repair": {
      "name": "Reparaciones",
      "description": "Fontanería, electricidad y pequeños arreglos. El técnico acuerda el presupuesto antes de empezar."
    },
    "transfer": {
      "name": "Traslado",
      "description": "Te recogemos en el aeropuerto o te llevamos a tu vuelo."
    },
    "social_card": {
      "name": "Tarjeta social",
      "description": "Te ayudamos a tramitar la tarjeta social."
    },
    "passport_translation": {
      "name": "Traducción del pasaporte",
      "description": "Traducción notarial del pasaporte."
    },
    "residence_permit": {
      "name": "Permiso de residencia",
      "description": "Acompañamiento hasta obtener la residencia."
    },
    "lang_armenian": {
      "name": "Armenio",
      "description": "Paquete de clases de armenio, en línea o presenciales."
    },
    "lang_english": {
      "name": "Inglés",
      "description": "Paquete de clases de inglés, en línea o presenciales."
    },
    "career": {
      "name": "Asesor de carrera",
      "description": "Revisión del CV y plan de búsqueda de empleo."
    }
  },
  "params": {
    "cleaning": {
      "cleaningType": {
        "label": "Tipo de limpieza",
        "regular": "Normal",
        "regular_hint": "Limpieza de mantenimiento",
        "general": "A fondo",
        "general_hint": "Todo, incluidos los rincones difíciles",
        "renovation": "Tras reforma",
        "renovation_hint": "Polvo, restos de pintura y cemento"
      },
      "rooms": {
        "label": "Habitaciones",
        "count_one": "{{count}} habitación",
        "count_few": "{{count}} habitaciones",
        "count_many": "{{count}} habitaciones",
        "count_other": "{{count}} habitaciones"
      },
      "bathrooms": {
        "label": "Baños",
        "count_one": "{{count}} baño",
        "count_few": "{{count}} baños",
        "count_many": "{{count}} baños",
        "count_other": "{{count}} baños"
      }
    },
    "repair": {
      "repairType": {
        "label": "Qué ha pasado",
        "plumbing": "Fontanería",
        "plumbing_hint": "Grifos, tuberías, inodoro",
        "electrical": "Electricidad",
        "electrical_hint": "Enchufes, luces, cableado",
        "minor": "Pequeños arreglos",
        "minor_hint": "Estantes, puertas, muebles"
      },
      "problem": {
        "label": "Describe el problema"
      }
    },
    "transfer": {
      "direction": {
        "label": "Dirección",
        "fromAirport": "Desde el aeropuerto",
        "fromAirport_hint": "Te esperamos con un cartel",
        "toAirport": "Al aeropuerto",
        "toAirport_hint": "Te llevamos a tu vuelo"
      },
      "flight": {
        "label": "Número de vuelo"
      },
      "passengers": {
        "label": "Pasajeros"
      },
      "luggage": {
        "label": "Bultos de equipaje"
      }
    },
    "social_card": {
      "forWhom": {
        "label": "Para quién",
        "self": "Para mí",
        "self_hint": "Una persona",
        "family": "Para mi familia",
        "family_hint": "Varias personas"
      }
    },
    "passport_translation": {
      "forWhom": {
        "label": "Para quién",
        "self": "Para mí",
        "self_hint": "Un pasaporte",
        "family": "Para mi familia",
        "family_hint": "Varios pasaportes"
      }
    },
    "residence_permit": {
      "forWhom": {
        "label": "Para quién",
        "self": "Para mí",
        "self_hint": "Una persona",
        "family": "Para mi familia",
        "family_hint": "Varias personas"
      }
    },
    "lang_armenian": {
      "level": {
        "label": "Nivel",
        "A1": "A1",
        "A1_hint": "Desde cero",
        "A2": "A2",
        "A2_hint": "Básico",
        "B1": "B1",
        "B1_hint": "Intermedio",
        "B2": "B2",
        "B2_hint": "Intermedio alto"
      },
      "format": {
        "label": "Formato",
        "online": "En línea",
        "online_hint": "Por videollamada",
        "offline": "Presencial",
        "offline_hint": "En Ereván"
      },
      "lessons": {
        "label": "Paquete",
        "4": "4 clases",
        "4_hint": "Para probar",
        "8": "8 clases",
        "8_hint": "Un mes",
        "12": "12 clases",
        "12_hint": "Intensivo"
      }
    },
    "lang_english": {
      "level": {
        "label": "Nivel",
        "A1": "A1",
        "A1_hint": "Desde cero",
        "A2": "A2",
        "A2_hint": "Básico",
        "B1": "B1",
        "B1_hint": "Intermedio",
        "B2": "B2",
        "B2_hint": "Intermedio alto",
        "C1": "C1",
        "C1_hint": "Avanzado"
      },
      "format": {
        "label": "Formato",
        "online": "En línea",
        "online_hint": "Por videollamada",
        "offline": "Presencial",
        "offline_hint": "En Ereván"
      },
      "lessons": {
        "label": "Paquete",
        "4": "4 clases",
        "4_hint": "Para probar",
        "8": "8 clases",
        "8_hint": "Un mes",
        "12": "12 clases",
        "12_hint": "Intensivo"
      }
    },
    "career": {
      "topic": {
        "label": "Tema",
        "resume": "Revisión del CV",
        "resume_hint": "Qué mejorar",
        "jobSearch": "Plan de búsqueda de empleo",
        "jobSearch_hint": "Dónde y cómo postular"
      }
    }
  },
  "extras": {
    "windows": {
      "name": "Limpieza de ventanas",
      "per": "por ventana"
    },
    "balconyGlazing": {
      "name": "Acristalamiento del balcón",
      "per": "por balcón"
    },
    "balcony": {
      "name": "Limpieza del balcón",
      "per": "por balcón"
    },
    "fridge": {
      "name": "Interior de la nevera"
    },
    "oven": {
      "name": "Interior del horno"
    },
    "microwave": {
      "name": "Interior del microondas"
    },
    "kitchenCabinets": {
      "name": "Interior de los armarios de cocina"
    },
    "complexKitchen": {
      "name": "Cocina muy sucia"
    },
    "chandelier": {
      "name": "Lámpara de techo",
      "per": "por unidad"
    },
    "wardrobe": {
      "name": "Vestidor"
    },
    "limescale": {
      "name": "Cal y óxido en el baño"
    },
    "petHair": {
      "name": "Eliminar pelo de mascotas"
    },
    "litter": {
      "name": "Arenero de mascota",
      "per": "por unidad"
    },
    "ironing": {
      "name": "Planchado",
      "per": "por hora"
    },
    "extraTime": {
      "name": "Tiempo adicional",
      "per": "por 30 min"
    },
    "keys": {
      "name": "Recoger y devolver llaves"
    },
    "experienced": {
      "name": "Limpiador/a con experiencia"
    },
    "vacuum": {
      "name": "Llevar aspiradora"
    }
  },
  "checklist": {
    "kitchen": "Cocina",
    "bathroom": "Baño",
    "rooms": "Habitaciones",
    "floors": "Suelos",
    "photoReport": "Reporte con fotos",
    "diagnostics": "Diagnóstico",
    "estimate": "Presupuesto",
    "repair": "Reparación",
    "photo": "Foto",
    "luggage": "Equipaje",
    "address": "Dirección",
    "review": "Repaso",
    "newTopic": "Tema nuevo",
    "homework": "Deberes",
    "resume": "CV",
    "plan": "Plan",
    "materials": "Materiales"
  },
  "status": {
    "CLEANING": {
      "NEW": "Nuevo",
      "ASSIGNED": "Asignado",
      "EN_ROUTE": "En camino",
      "CLEANING": "Limpiando",
      "DONE": "Listo",
      "CANCELLED": "Cancelado"
    },
    "REPAIR": {
      "NEW": "Nuevo",
      "ASSIGNED": "Asignado",
      "ON_SITE": "En el lugar",
      "ESTIMATE_APPROVED": "Presupuesto aprobado",
      "REPAIRING": "Reparando",
      "DONE": "Listo",
      "CANCELLED": "Cancelado"
    },
    "TRANSFER": {
      "NEW": "Nuevo",
      "ASSIGNED": "Asignado",
      "DRIVER_WAITING": "El conductor espera",
      "RIDE_IN_PROGRESS": "En camino",
      "COMPLETED": "Completado",
      "CANCELLED": "Cancelado"
    },
    "LANGUAGE": {
      "ENROLLED": "Inscrito",
      "LESSON_SCHEDULED": "Clase programada",
      "LESSON_IN_PROGRESS": "Clase en curso",
      "LESSON_DONE": "Clase terminada",
      "COMPLETED": "Paquete completado",
      "CANCELLED": "Cancelado"
    },
    "CAREER": {
      "NEW": "Nuevo",
      "CONSULTANT_ASSIGNED": "Asesor asignado",
      "RESUME_RECEIVED": "CV recibido",
      "MEETING": "Reunión",
      "PLAN_SENT": "Plan enviado",
      "CANCELLED": "Cancelado"
    },
    "DOCUMENTS": {
      "NEW": "Nuevo",
      "DOCS_REVIEW": "Revisando documentos",
      "NEEDS_MORE_DOCS": "Faltan documentos",
      "SUBMITTED": "Presentado",
      "DONE": "Listo",
      "CANCELLED": "Cancelado"
    }
  },
  "payment": {
    "UNPAID": "Sin pagar",
    "PAID": "Pagado",
    "REFUNDED": "Reembolsado"
  },
  "roles": {
    "CLEANER": "Limpiador/a",
    "HANDYMAN": "Técnico",
    "DRIVER": "Conductor",
    "TEACHER": "Profesor/a",
    "CAREER_CONSULTANT": "Asesor de carrera",
    "DOCS_AGENT": "Especialista en documentos"
  },
  "districts": {
    "ajapnyak": "Ajapnyak",
    "arabkir": "Arabkir",
    "avan": "Avan",
    "davtashen": "Davtashen",
    "erebuni": "Erebuni",
    "kanaker_zeytun": "Kanaker-Zeytun",
    "kentron": "Kentron",
    "malatia_sebastia": "Malatia-Sebastia",
    "nork_marash": "Nork-Marash",
    "nor_nork": "Nor Nork",
    "nubarashen": "Nubarashen",
    "shengavit": "Shengavit"
  },
  "plans": {
    "free": {
      "perks": "Descuentos y regalos de socios",
      "prices": "Todos los servicios a precio normal",
      "status": "Estado de pedidos y chat"
    },
    "plus": {
      "price": "{{price}}/mes",
      "all": "Todo lo de Barev",
      "discount": "−{{pct}}% en «{{category}}»"
    }
  },
  "errors": {
    "generic": "Algo salió mal. Inténtalo de nuevo.",
    "NOT_FOUND": "No encontramos este pedido.",
    "FORBIDDEN": "Acceso denegado.",
    "CONSENT_REQUIRED": "Primero necesitamos tu consentimiento para el tratamiento de datos personales.",
    "SERVICE_UNAVAILABLE": "Este servicio aún no está disponible.",
    "INVALID_PARAMS": "Revisa los datos del pedido.",
    "SLOT_UNAVAILABLE": "Esta hora acaba de ocuparse. Elige otra.",
    "ADDRESS_REQUIRED": "Indica el distrito y la dirección.",
    "TRANSITION_NOT_ALLOWED": "Este paso no está disponible ahora. Actualiza la pantalla.",
    "CHECKLIST_INCOMPLETE": "Marca todos los puntos de la lista.",
    "PHOTO_REQUIRED": "Este punto necesita una foto.",
    "ESTIMATE_NOT_ACCEPTED": "El cliente aún no ha aprobado el presupuesto.",
    "CANCEL_VIA_OPERATOR": "El servicio ya empezó: solo un operador puede cancelarlo.",
    "RESCHEDULE_VIA_OPERATOR": "Solo un operador puede cambiar la fecha.",
    "AGENCY_CODE_INVALID": "Ese código no existe. Revisa el código de tu contrato.",
    "AGENCY_ALREADY_SET": "Ya estás vinculado a otra agencia inmobiliaria.",
    "OFFER_NOT_ACTIVE": "Esta oferta ya no es válida.",
    "PROVIDER_BUSY": "El especialista está ocupado a esa hora.",
    "ALREADY_ASSIGNED": "El pedido ya está asignado.",
    "INVITE_INVALID": "El enlace de invitación no es válido. Pide uno nuevo al operador.",
    "NOT_PAID_STATE": "Este pedido no se puede marcar como pagado.",
    "BAD_CREDENTIALS": "Usuario o contraseña incorrectos.",
    "BAD_TOTP": "Código incorrecto. Revisa la hora del teléfono.",
    "LOGIN_THROTTLED": "Demasiados intentos. Espera 15 minutos.",
    "OWNER_ONLY": "Solo para el propietario.",
    "NOT_LINKED": "Cuenta no vinculada.",
    "NOT_PROVIDER": "Solo para especialistas.",
    "CANNOT_DISABLE_SELF": "No puedes desactivarte a ti mismo.",
    "AGENCY_CODE_FORMAT": "El código debe tener letras latinas y números.",
    "TOTP_ALREADY_ENABLED": "La 2FA ya está configurada.",
    "ADMIN_LOGIN_REQUIRED": "Inicia sesión.",
    "ADMIN_2FA_REQUIRED": "Confirma el acceso con un código.",
    "INIT_DATA_MISSING": "Abre la app desde Telegram.",
    "INIT_DATA_BAD_HASH": "Abre la app desde Telegram.",
    "INIT_DATA_EXPIRED": "La sesión caducó. Vuelve a abrir la app.",
    "BAD_FILE_TYPE": "Se necesita una foto (JPG, PNG, WEBP).",
    "NO_FILE": "No se seleccionó ningún archivo.",
    "UPLOAD": "No se pudo subir la foto.",
    "PHONE_INVALID": "Revisa el número de teléfono.",
    "REQUEST_THROTTLED": "Demasiadas solicitudes seguidas. Inténtalo dentro de 15 minutos.",
    "CONTACT_INVALID": "Necesitamos un teléfono (+374…) o un usuario de Telegram (@usuario).",
    "NAME_REQUIRED": "Dinos cómo llamarte.",
    "PROVIDER_NOT_LINKED": "El profesional aún no ha abierto el bot con la invitación: no hay dónde escribirle.",
    "CARD_EXPIRED": "El QR caducó o no es válido: pide al cliente que vuelva a abrir la tarjeta.",
    "OFFER_NOT_AVAILABLE": "Esta oferta no está disponible en el nivel del cliente.",
    "OFFER_LIMIT_REACHED": "Ya se agotó el límite de esta oferta.",
    "CONCIERGE_SUBSCRIBERS_ONLY": "El conserje personal es para miembros de Barev+ y Barev Elite. De momento, escribe a soporte: también te ayudaremos.",
    "ASSIGNEE_NO_ACCESS": "Esta persona del equipo no tiene acceso a este canal.",
    "PROMO_INVALID": "Este código no existe",
    "PROMO_EXPIRED": "El código ya no es válido",
    "PROMO_USED": "Este código ya se ha usado",
    "PROMO_NOT_FOR_SERVICE": "El código no es válido para este servicio",
    "POINTS_DUPLICATE_ORDER": "Ya se acreditaron bariki por este pedido.",
    "POINTS_REASON_REQUIRED": "Indica el motivo.",
    "POINTS_BELOW_MIN": "La cantidad es inferior al mínimo.",
    "POINTS_NOT_ENOUGH": "No tienes suficientes bariki.",
    "POINTS_OVER_SHARE": "Con bariki solo se puede pagar una parte del pedido.",
    "POINTS_OVER_LIMIT": "Supera tu límite: debe aprobarlo un superadministrador.",
    "POINTS_FINAL": "Esta operación ya no se puede anular.",
    "POINTS_REQUEST_CLOSED": "La solicitud ya se gestionó o caducó.",
    "POINTS_TOO_MANY_REQUESTS": "Ya tienes solicitudes pendientes: espera la respuesta.",
    "POINTS_WITH_PROMO": "Los bariki no se combinan con un código promocional.",
    "PAYMENT_UNAVAILABLE": "El pago en línea no está disponible ahora — escribe a un operador.",
    "PAYMENT_AMOUNT_OUT_OF_RANGE": "Este importe no se puede pagar en línea — un operador te ayudará.",
    "ALREADY_SUBSCRIBED": "Ya tienes una membresía con renovación automática.",
    "PAYMENT_PROVIDER_ERROR": "El servicio de pago no respondió. Inténtalo de nuevo más tarde."
  },
  "client": {
    "nav": {
      "label": "Navegación",
      "home": "Inicio",
      "services": "Servicios",
      "newOrder": "Nuevo pedido",
      "perks": "Descuentos",
      "profile": "Perfil",
      "plan": "Plan",
      "docs": "Documentos",
      "orders": "Pedidos",
      "card": "Tarjeta",
      "chat": "Chat"
    },
    "openInTelegram": {
      "title": "Abre en Telegram",
      "text": "Barev Club funciona dentro de Telegram. Pulsa «Abrir la app» en nuestro bot."
    },
    "consent": {
      "title": "Casi listo",
      "text": "Para hacer pedidos necesitamos tu consentimiento para tratar datos personales: nombre, dirección y detalles del pedido. Los reciben el especialista de tu pedido y los socios indicados en la política, y se guardan en un servidor en Alemania.",
      "policyLink": "Política de privacidad",
      "accept": "Acepto, continuar",
      "giftToast": "El regalo de tu agencia inmobiliaria está activado"
    },
    "home": {
      "hello": "¡Barev!",
      "guest": "Amigo",
      "myOrders": "Mis pedidos",
      "allOrders": "Todos",
      "noOrders": "Aún no tienes pedidos. Reserva tu primer servicio: son 2 minutos.",
      "repeatLast": "Repetir",
      "enterCode": "Código de la agencia inmobiliaria",
      "plusUntil": "Barev+ activo hasta el {{date}}",
      "discount": "−{{pct}}% con Barev+",
      "upsellTitle": "Hasta −{{pct}}% con Barev Elite",
      "upsellText": "Limpieza, reparaciones, traslados, trámites y regalos de socios",
      "levelUntil": "{{plan}} activo hasta el {{date}}",
      "now": "Ahora",
      "moreActive": "Más activos: {{count}}",
      "orderTitle": "Reservar",
      "cardShow": "Mostrar QR",
      "free": "Nivel gratuito",
      "chatTitle": "Cualquier pregunta, al chat",
      "chatText": "Respondemos en tu idioma"
    },
    "services": {
      "title": "Servicios",
      "plusDiscount": "Tu descuento Barev+: −{{pct}}%",
      "callback": "Dejar solicitud",
      "yourDiscount": "Tu descuento −{{pct}}%",
      "withElite": "Con Barev Elite, −{{pct}}%"
    },
    "order": {
      "unavailable": "Este servicio llegará muy pronto.",
      "duration": "Unas {{hours}} h",
      "when": "Cuándo",
      "date": "Fecha",
      "noSlots": "No hay horas libres este día. Elige otro.",
      "pickSlot": "Elige una hora.",
      "address": "Dirección",
      "district": "Distrito",
      "districtPlaceholder": "Elige un distrito",
      "pickDistrict": "Elige un distrito.",
      "addressLabel": "Calle, número, piso",
      "addressPlaceholder": "Calle Pushkin 10, piso 15",
      "enterAddress": "Indica la dirección.",
      "note": "Nota para el especialista",
      "notePlaceholder": "Portero, piso, mascotas…",
      "payment": "Pago",
      "paymentHint": "Pagas al terminar. El pago en línea llegará más adelante.",
      "price": "Precio",
      "discount": "Descuento Barev+ −{{pct}}%",
      "plusHint": "Con Barev+ sería un {{pct}}% más barato",
      "total": "Total",
      "confirm": "Confirmar pedido",
      "cancelPolicy": "Cancelación y cambio gratis hasta {{hours}} h antes. Después, se retiene un {{pct}}%.",
      "created": "Pedido n.º {{number}} creado",
      "extras": "Extras",
      "add": "Añadir",
      "promo": "Código promocional",
      "promoPlaceholder": "Código promocional, si tienes",
      "promoApply": "Aplicar",
      "promoRemove": "Quitar",
      "promoLine": "Código {{code}} −{{pct}}%",
      "promoWeaker": "El descuento de tu suscripción es mayor y se aplica ese"
    },
    "orders": {
      "title": "Mis pedidos",
      "active": "Activos",
      "history": "Historial",
      "noHistory": "Aquí verás los pedidos terminados.",
      "order": "Reservar un servicio"
    },
    "detail": {
      "progress": "Estado",
      "arrived": "ha llegado",
      "photoReport": "Reporte con fotos",
      "cancelFee": "Retención por cancelación",
      "reschedule": "Cambiar fecha",
      "rescheduleConfirm": "Cambiar a esta hora",
      "rescheduled": "Pedido reprogramado",
      "cancel": "Cancelar pedido",
      "confirmCancelFree": "¿Cancelar el pedido? La cancelación es gratis.",
      "confirmCancelLate": "Falta menos de un día: retendremos {{fee}} ({{pct}}%). ¿Cancelar?",
      "cancelled": "Pedido cancelado",
      "cancelledWithFee": "Pedido cancelado. Retención: {{fee}}",
      "viaOperator": "Con menos de {{hours}} h de antelación, solo puedes cancelar o cambiar el pedido a través de un operador: escribe al bot.",
      "repeat": "Repetir pedido",
      "orderAgain": "Pedir de nuevo",
      "providerLabel": {
        "CLEANING": "Limpiador/a",
        "REPAIR": "Técnico",
        "TRANSFER": "Conductor",
        "LANGUAGE": "Profesor/a",
        "CAREER": "Asesor",
        "DOCUMENTS": "Especialista"
      },
      "when": "Cuándo",
      "where": "Dónde",
      "who": "Profesional",
      "whoPending": "asignando",
      "payment": "Pago",
      "ask": "Pregunta sobre el pedido",
      "payOnline": "Pagar en línea · {{price}}",
      "payOnlineHint": "Con tarjeta vía Tribute, en euros al tipo de cambio: {{amd}} ≈ {{rub}}",
      "payAwaiting": "Esperando la confirmación del pago…",
      "paidOnline": "¡Pago recibido, gracias!"
    },
    "perks": {
      "title": "Descuentos",
      "soonTitle": "Socios muy pronto",
      "soonText": "Aquí aparecerán cafeterías, restaurantes y regalos de socios. Muestra tu tarjeta del club al pagar."
    },
    "profile": {
      "title": "Perfil",
      "fromAgency": "Cliente de la agencia inmobiliaria {{agency}}",
      "noAgency": "Sin agencia inmobiliaria",
      "membership": "Membresía Barev / Barev+",
      "codeTitle": "Código de la agencia inmobiliaria",
      "codeText": "¿Alquilaste con una agencia inmobiliaria asociada? Introduce el código del contrato y recibe el regalo de la agencia.",
      "codePlaceholder": "p. ej., DOMIK",
      "codeAccepted": "Código aceptado: {{agency}}",
      "codeGift": "Código aceptado: {{agency}}. ¡Tu regalo está activado!",
      "language": "Idioma"
    },
    "membership": {
      "title": "Membresía",
      "current": "Tu plan",
      "howToGet": "Puedes recibir Barev+ de regalo con el código de una agencia inmobiliaria. La suscripción en línea llegará muy pronto.",
      "request": "Contratar {{plan}}",
      "requested": "Solicitud enviada: un operador te contactará",
      "requestHint": "Un operador te escribirá por Telegram, acordará el pago y activará la suscripción.",
      "pendingTitle": "Solicitud enviada",
      "pendingText": "Un operador te contactará pronto para activar la suscripción.",
      "approx": "≈ {{amd}} · ≈ {{rub}} — se cobra en euros",
      "pay": "Obtener {{plan}} por {{price}}/mes",
      "payRenew": "Activar renovación automática · {{price}}/mes",
      "payHint": "Pago con tarjeta vía Tribute. Se renueva cada mes; puedes desactivarlo aquí en cualquier momento.",
      "payOther": "Pagar de otra forma — con un operador",
      "renewOn": "Renovación automática activada",
      "nextCharge": "Próximo cargo el {{date}} — {{price}}",
      "renewOffButton": "Desactivar renovación automática",
      "renewOffConfirm": "¿Desactivar la renovación automática? La membresía sigue activa hasta el final del mes pagado.",
      "renewOff": "Renovación automática desactivada",
      "switchHint": "Tienes {{plan}} con renovación automática. Para cambiar de plan, desactívala primero.",
      "awaitingTitle": "Esperando la confirmación del pago",
      "awaitingText": "Suele tardar unos segundos. La membresía se activará automáticamente.",
      "paid": "Pago recibido — membresía activada"
    },
    "segment": {
      "title": "¡Hola! Cuéntanos de ti",
      "sub": "Te mostraremos lo que necesitas. Puedes cambiarlo en el perfil.",
      "moving": "Me mudo",
      "movingText": "Plan de mudanza paso a paso, documentos y conserje",
      "living": "Ya vivo en Armenia",
      "livingText": "Servicios con descuento, socios del club y pedidos",
      "profileTitle": "Mi escenario"
    },
    "move": {
      "title": "Mi mudanza",
      "daysLeft_one": "en {{count}} día",
      "daysLeft_few": "en {{count}} días",
      "daysLeft_many": "en {{count}} días",
      "daysLeft_other": "en {{count}} días",
      "progress": "{{done}} de {{total}} pasos hechos",
      "noSteps": "Un operador te contactará y preparará el plan; los pasos aparecerán aquí.",
      "afterTitle": "¿Ya te mudaste?",
      "afterText": "Cambia en el perfil a «Ya vivo en Armenia»: allí tienes servicios con descuento y socios del club.",
      "formHello": "{{name}}, empecemos",
      "formTitle": "Armemos tu mudanza",
      "formSub": "Responde un par de preguntas y un operador preparará el plan y el precio.",
      "whenTitle": "¿Cuándo te mudas?",
      "packageTitle": "¿Qué necesitas?",
      "customTitle": "Marca los servicios que necesitas",
      "errPackage": "Elige un paquete.",
      "errWhen": "Elige una opción o indica la fecha.",
      "errEmpty": "Marca al menos un servicio.",
      "comment": "Comentario",
      "commentHint": "Cuántos sois, si hay niños o mascotas, qué es importante",
      "submit": "Enviar el plan",
      "created": "Plan enviado: un operador te contactará pronto",
      "status": {
        "TODO": "pendiente",
        "IN_PROGRESS": "en curso",
        "DONE": "hecho",
        "SKIPPED": "no hace falta"
      }
    },
    "docs": {
      "title": "Documentos",
      "sub": "Qué preparar antes de la mudanza. Márcalo para no olvidar nada.",
      "progress": "{{done}} de {{total}} listos",
      "needPlan": "Primero arma el plan de mudanza y luego marca los documentos.",
      "ask": "Preguntar al conserje"
    },
    "concierge": {
      "title": "Conserje",
      "short": "Escribe en el chat y te responderemos allí"
    },
    "request": {
      "title": "Dejar solicitud",
      "sub": "Un operador te contactará, concretará los detalles y hará el pedido.",
      "comment": "Qué hay que hacer",
      "commentHint": "Por ejemplo: gotea el grifo de la cocina, mejor después de las 18:00",
      "submit": "Enviar solicitud",
      "sentTitle": "Solicitud n.º {{number}} enviada",
      "sentText": "Un operador te contactará en horario laboral.",
      "back": "A los servicios",
      "yourDiscount": "Tu descuento por suscripción −{{pct}}%"
    },
    "partners": {
      "howTo": "Enseña el QR en caja: el personal lo escanea con la cámara. El código cambia cada minuto, una captura no sirve.",
      "cat": {
        "cafe": "Café",
        "restaurant": "Restaurante",
        "shop": "Tienda",
        "beauty": "Belleza",
        "other": "Otros"
      },
      "qrLabel": "QR de la tarjeta del club",
      "qrRefresh": "se renueva en {{seconds}} s",
      "allMembers": "todos los socios",
      "needLevel": "con {{level}}",
      "limit_ONCE": "primera visita",
      "limit_WEEK": "{{count}}× por semana",
      "limit_MONTH": "{{count}}× al mes",
      "used_ONCE": "ya usado",
      "used_WEEK": "de nuevo la próxima semana",
      "used_MONTH": "de nuevo el próximo mes"
    },
    "chat": {
      "title": "Chat con Barev Club",
      "support": "Soporte",
      "concierge": "Conserje personal",
      "hint": "Es la misma conversación que en el chat del bot: la respuesta llegará aquí y a Telegram.",
      "empty": "Cuéntanos en qué podemos ayudarte: te responderemos aquí.",
      "placeholder": "Mensaje…",
      "send": "Enviar",
      "attach": "Adjuntar foto o archivo",
      "conciergeOnly": "El conserje personal está incluido en Barev+ y Barev Elite",
      "team": "Barev Club",
      "fileTooBig": "El archivo supera los 10 MB",
      "file": "Archivo"
    },
    "rate": {
      "title": "¿Qué tal fue?",
      "text": "Tu valoración nos ayuda a cuidar la calidad",
      "comment": "Comentario (opcional)",
      "send": "Valorar",
      "thanks": "¡Gracias por tu valoración!",
      "yours": "Tu valoración",
      "change": "Cambiar",
      "star": "{{count}} de 5",
      "prompt": "Valora tu pedido"
    },
    "card": {
      "title": "Tarjeta del club",
      "partners": "Socios del club",
      "plans": "Niveles y descuentos"
    },
    "points": {
      "title": "Bariki",
      "balance": "Disponible",
      "equals": "bariki ≈ {{amount}} ֏ · 1 bariki = 1 ֏",
      "pending": "pendientes: {{amount}}, disponibles desde el {{date}}",
      "burn": "{{amount}} caducan el {{date}}: cualquier pedido los conserva",
      "pay": "Pagar con bariki",
      "enterCode": "Introducir código",
      "requestPending": "Tu solicitud de pago con bariki espera confirmación.",
      "rates": "Cashback por categoría",
      "plusWouldGet": "Con Barev+ tendrías +{{amount}} bariki más en los últimos 30 días →",
      "streak": "Racha de limpiezas",
      "streakLeft": "{{left}} más y el cashback de limpieza sube +{{bonus}}%. Pausas de hasta {{days}} días.",
      "streakMax": "Racha máxima: +{{bonus}}% de cashback en cada limpieza.",
      "route": "Ruta del primer mes",
      "routeText": "Reserva servicios de 3 categorías distintas antes del {{date}} y recibe {{amount}} bariki. Ahora: {{done}} de 3.",
      "history": "Historial",
      "empty": "Ganas bariki con cada pedido pagado: cashback según tu nivel.",
      "availableFrom": "disponibles desde el {{date}}",
      "until": "hasta el {{date}}",
      "payHint": "Con bariki pagas hasta el {{pct}}% del pedido, mínimo {{min}}. El equipo confirmará y te enviará el importe restante.",
      "forOrder": "Pedido",
      "otherOrder": "Otro pedido (fuera de la app)",
      "amount": "Cuántos bariki usar",
      "max": "Máximo: {{max}}",
      "note": "Comentario",
      "notePh": "Qué pedido y por qué importe",
      "send": "Enviar solicitud",
      "requested": "Solicitud enviada: te responderemos en el chat.",
      "useInOrder": "Usar {{amount}} bariki",
      "useHint": "hasta el {{pct}}% del pedido · saldo {{balance}}",
      "notWithPromo": "No junto con un código promocional",
      "belowMin": "Mínimo {{min}} · saldo {{balance}}",
      "paidLine": "Pagado con bariki",
      "type": {
        "accrual": "Cashback",
        "bonus": "Bono",
        "redemption": "Pago con bariki",
        "request": "Solicitud de pago",
        "reversal": "Anulación"
      },
      "status": {
        "PENDING": "pendiente",
        "ACTIVE": "disponible",
        "SPENT": "gastado",
        "EXPIRED": "caducado",
        "REVERSED": "anulado",
        "REQUESTED": "pendiente de confirmación",
        "CONFIRMED": "canjeado",
        "REJECTED": "rechazado",
        "ACCRUAL": "abono anulado",
        "REDEMPTION": "bariki devueltos"
      }
    }
  },
  "pro": {
    "nav": {
      "label": "Navegación",
      "today": "Hoy",
      "history": "Historial",
      "company": "Empresa",
      "partner": "Socio"
    },
    "openInTelegram": {
      "title": "Abre en Telegram",
      "text": "El panel del especialista se abre desde el bot Barev Pro."
    },
    "notLinked": {
      "title": "Cuenta no vinculada",
      "text": "Pide al operador un enlace de invitación y ábrelo en Telegram."
    },
    "today": {
      "onShift": "En turno",
      "offShift": "Fuera de turno",
      "earned": "Ganado",
      "orders": "Pedidos",
      "rating": "Valoración",
      "now": "Ahora",
      "open": "Abrir pedido",
      "title": "Pedidos de hoy",
      "empty": "Hoy no hay pedidos.",
      "upcoming": "Próximos"
    },
    "offer": {
      "title": "Nuevo pedido",
      "accept": "Aceptar",
      "decline": "Rechazar",
      "accepted": "Pedido aceptado",
      "declined": "Has rechazado el pedido",
      "left": "quedan"
    },
    "action": {
      "depart": "Voy en camino",
      "arrived": "He llegado",
      "startCleaning": "Empezar la limpieza",
      "finishCleaning": "Terminar y enviar fotos",
      "startWork": "Empezar el trabajo",
      "closeRepair": "Cerrar pedido",
      "atPickup": "Estoy en el aeropuerto",
      "passengerIn": "Pasajero a bordo",
      "finishRide": "Terminar el viaje",
      "scheduleLesson": "Programar clase",
      "openLesson": "Abrir clase",
      "startLesson": "Empezar",
      "finishLesson": "Terminar clase",
      "openMeeting": "Abrir reunión",
      "startMeeting": "Empezar",
      "finishMeeting": "Terminar"
    },
    "job": {
      "when": "Cuándo",
      "where": "Dónde",
      "client": "Cliente",
      "clientLanguage": "idioma",
      "price": "Importe",
      "checklist": "Lista de control",
      "checklistFirst": "Para terminar, marca todos los puntos y adjunta una foto.",
      "takePhoto": "Hacer foto",
      "retakePhoto": "Repetir",
      "confirmFinish": "¿Terminar el pedido? El cliente recibirá un aviso y el reporte con fotos.",
      "markPaid": "El cliente ha pagado",
      "confirmPaid": "¿Confirmas que el cliente pagó {{amount}}?",
      "paidMarked": "Pago registrado"
    },
    "history": {
      "title": "Historial",
      "week": "7 días",
      "month": "Este mes",
      "prevMonth": "Mes pasado",
      "earned": "Ganado",
      "done": "Completados",
      "empty": "No hay pedidos en este periodo.",
      "ratePercent": "Tarifa: {{value}}% del pedido",
      "rateFixed": "Tarifa: {{value}} por pedido",
      "ratePreset": "Tarifa: plantilla «{{name}}»",
      "ratePartner": "Tu empresa fija tu pago por pedido"
    },
    "company": {
      "title": "Empresa",
      "pending": "Pendientes de asignar",
      "noPending": "Todos los pedidos están asignados.",
      "assign": "Asignar a alguien del equipo",
      "chooseStaff": "Quién se encarga",
      "assigned": "Asignados",
      "noAssigned": "Nada por ahora.",
      "assigned_ok": "Asignado al equipo",
      "staff": "Equipo",
      "notLinked": "no está en el bot",
      "free": "libre",
      "busy": "ocupado",
      "speaksLanguage": "idioma del cliente",
      "load_one": "{{count}} pedido ese día",
      "load_few": "{{count}} pedidos ese día",
      "load_many": "{{count}} pedidos ese día",
      "load_other": "{{count}} pedidos ese día"
    },
    "partner": {
      "owner": "propietario",
      "staff": "equipo",
      "visits30_one": "{{count}} comprobación en 30 días",
      "visits30_few": "{{count}} comprobaciones en 30 días",
      "visits30_many": "{{count}} comprobaciones en 30 días",
      "visits30_other": "{{count}} comprobaciones en 30 días",
      "scan": "Escanear QR del cliente",
      "scanSub": "Muestra el nivel del cliente y qué le corresponde",
      "scanHint": "Apunta la cámara al QR de la app del cliente",
      "noScanner": "El escáner solo funciona dentro de Telegram. Puedes escribir el código.",
      "manual": "O pega el código / enlace del QR",
      "check": "Comprobar",
      "valid": "{{name}} — {{level}}",
      "until": "suscripción hasta el {{date}}",
      "needLevel": "requiere {{level}}",
      "unlimited": "sin límite",
      "redeemed": "Canjeado: {{offer}}",
      "offers": "Tus ofertas para el club",
      "noOffers": "Aún no hay ofertas.",
      "offersHint": "Para cambiar las ofertas, escribe al operador del club.",
      "allMembers": "todos los socios",
      "limit_ONCE": "solo la primera visita",
      "limit_WEEK": "{{count}}× por semana",
      "limit_MONTH": "{{count}}× al mes",
      "team": "Equipo",
      "invite": "Invitar",
      "inviteQr": "QR de invitación",
      "inviteHint": "El empleado escanea este QR con la cámara y pulsa Start. De un solo uso, válido hasta {{time}}.",
      "inviteLink": "O envía el enlace",
      "remove": "Quitar",
      "removeConfirm": "¿Quitar a {{name}} del equipo?",
      "recent": "Últimas comprobaciones",
      "noRecent": "Aún no hay comprobaciones.",
      "checked": "comprobación"
    },
    "web": {
      "loginHint": "Abre el bot de trabajo y pulsa «Abrir en el ordenador» (o envía /web): recibirás un enlace de acceso."
    },
    "cab": {
      "tab": {
        "orders": "Pedidos",
        "staff": "Personal",
        "money": "Ingresos",
        "settings": "Ajustes"
      },
      "autoOn": "La asignación automática está activada: los pedidos nuevos van solos al personal libre.",
      "income": "Tu ingreso",
      "deadline": "asigna antes de las {{time}}",
      "offeredTo": "esperando a {{name}}",
      "decline": "Rechazar",
      "declineConfirm": "¿Rechazar el pedido? Volverá a Barev Club.",
      "declined": "Pedido devuelto",
      "reassign": "Reasignar",
      "unassignConfirm": "¿Quitar a {{name}} del pedido? Volverá a esperar asignación.",
      "unassigned": "Empleado retirado del pedido",
      "gapHint": "Tiempo de traslado entre pedidos: {{min}} min.",
      "noStaff": "Aún no hay personal: añádelo en la pestaña «Personal».",
      "dayLoad": "ese día {{n}}/{{max}}",
      "weekLoad": "esta semana {{n}}",
      "district": "distrito",
      "check": {
        "ok": "Libre",
        "busy": "Ocupado",
        "gap": "No llega a tiempo",
        "limit": "Límite diario",
        "notLinked": "No está en el bot",
        "gap_confirm": "Hay menos tiempo de traslado del establecido. ¿Asignar igualmente?",
        "limit_confirm": "Ya alcanzó su límite de pedidos u horas de ese día. ¿Asignar igualmente?",
        "notLinked_confirm": "Aún no entró en el bot de trabajo y no recibirá aviso. ¿Asignar?",
        "busy_confirm": "Está ocupado a esa hora."
      },
      "addStaff": "Añadir empleado",
      "todayLoad": "hoy {{n}}/{{max}}",
      "hoursMax": "hasta {{n}} h al día",
      "off": "desactivado",
      "staffAdded": "Empleado añadido",
      "saved": "Guardado",
      "inviteText": "Envía este enlace al empleado: abrirá el bot de trabajo y podrá aceptar pedidos.",
      "done": "Listo",
      "f": {
        "name": "Nombre",
        "phone": "Teléfono",
        "languages": "Idiomas",
        "districts": "Distritos (vacío: cualquiera)",
        "days": "Días laborables",
        "from": "Desde",
        "to": "Hasta",
        "maxOrders": "Máx. pedidos al día",
        "maxHours": "Máx. horas al día",
        "loadHint": "Vacío: sin límite. La asignación automática no le dará más."
      },
      "save": "Guardar",
      "resetInvite": "Nuevo enlace de acceso",
      "resetConfirm": "¿Crear un enlace nuevo? Se desconectará el acceso actual al bot.",
      "turnOff": "Desactivar",
      "turnOn": "Activar",
      "offConfirm": "¿Desactivar a {{name}}? No recibirá pedidos nuevos.",
      "copy": "Copiar",
      "copied": "Copiado",
      "balance": "Pendiente de pago",
      "accrued": "Acumulado",
      "paidOut": "Pagado",
      "terms": {
        "COMMISSION": "Condiciones: Barev Club se queda con el {{pct}}% de cada pedido pagado y el resto es tuyo. Salarios y gastos corren de tu cuenta.",
        "PROFIT_SHARE": "Condiciones: Barev Club paga al limpiador ({{fot}}%) y el impuesto ({{tax}}%); tú recibes el {{pct}}% del resto."
      },
      "byMonth": "Por meses",
      "ordersN": "pedidos: {{n}}",
      "byOrder": "Por pedido",
      "noIncome": "Los ingresos aparecen cuando el cliente paga un pedido realizado.",
      "paidBy": "pagado {{sum}}",
      "minus": "−nómina {{fot}}, −impuesto {{tax}}, tu {{pct}}%",
      "minusCommission": "−{{pct}}% Barev Club",
      "payouts": "Pagos",
      "payout": {
        "paid": "pagado",
        "pending": "pendiente"
      },
      "auto": "Asignación automática",
      "autoHint": "Un pedido nuevo se ofrece al mejor empleado libre: libre según su horario, con tiempo de traslado y dentro de sus límites; tienen prioridad quienes hablan el idioma del cliente, trabajan en el distrito, tienen menos pedidos esta semana y mejor valoración. Si lo rechaza o no responde, pasa al siguiente.",
      "gap": "Tiempo de traslado entre pedidos, min",
      "gapMin": "Mínimo {{min}} min",
      "timeoutHint": "Si un pedido no se asigna en {{min}} min, vuelve a Barev Club.",
      "managers": "Gestores",
      "you": "tú",
      "remove": "Quitar",
      "removeManagerConfirm": "¿Quitar a {{name}} de gestores?",
      "managerInvite": "Enlace para otro gestor: abrirá el bot de trabajo y tendrá acceso al panel:",
      "logout": "Cerrar sesión en este ordenador",
      "wd": {
        "0": "Lu",
        "1": "Ma",
        "2": "Mi",
        "3": "Ju",
        "4": "Vi",
        "5": "Sá",
        "6": "Do"
      }
    }
  },
  "bot": {
    "client": {
      "chooseLanguage": "Выбери язык · Choose your language · 选择语言 · Ընտրեք լեզուն · Elige tu idioma",
      "languageSet": "Idioma: {{language}}",
      "fromAgency": "¡Hola! Vienes de la agencia inmobiliaria {{agency}}: tenemos un regalo para ti.",
      "consentText": "Para usar Barev Club necesitamos tu consentimiento para tratar datos personales. Los reciben el especialista de tu pedido y los socios indicados en la política, y se guardan en un servidor en Alemania.\n\n<a href=\"{{url}}\">Política de privacidad</a>",
      "consentAccept": "Acepto",
      "giftActivated": "🎁 Regalo de tu agencia inmobiliaria: {{plan}} activo hasta el {{date}}. Los descuentos ya se aplican.",
      "welcome": "Ereván como en casa. Desde el primer día.\n\nReserva limpieza y otros servicios, sigue su estado y disfruta de descuentos de socios, todo en la app.",
      "openApp": "Abrir la app",
      "enterCode": "Introducir código de la agencia inmobiliaria",
      "changeLanguage": "Cambiar idioma",
      "codePrompt": "Envía el código de la agencia inmobiliaria de tu contrato de alquiler.",
      "codeAccepted": "Código aceptado: {{agency}}.",
      "help": "Pulsa «Abrir la app» para reservar un servicio. Comandos: /app — la app, /code — código de la agencia inmobiliaria, /language — idioma.",
      "cmdStart": "Empezar",
      "cmdApp": "Abrir la app",
      "cmdCode": "Introducir código de la agencia inmobiliaria",
      "cmdLanguage": "Cambiar idioma",
      "cmdHelp": "Ayuda",
      "webRequestOrdered": "Solicitud n.º {{request}} recibida y registrada como pedido n.º {{order}} para el {{date}}. El estado está en la app.",
      "webRequestLinked": "Solicitud n.º {{request}} recibida. Un operador te contactará para confirmar la hora.",
      "conciergeReceived": "Lo hemos pasado al conserje: te responderemos aquí, en este chat.",
      "supportReceived": "Lo hemos pasado a soporte: te responderemos aquí, en este chat.",
      "channelSupport": "Ahora escribes a soporte. Envía un mensaje, una foto o un archivo.",
      "channelConcierge": "Ahora escribes a tu conserje personal. Envía un mensaje, una foto o un archivo.",
      "cmdSupport": "Escribir a soporte",
      "cmdConcierge": "Escribir al conserje (Barev+)",
      "rated": "¡Gracias por tu valoración! {{stars}}",
      "ratedLow": "Lamentamos que no fuera bien. Cuéntanos aquí qué pasó y el equipo lo resolverá.",
      "wr": {
        "intro": "Tenemos tu solicitud n.º {{request}}. Solo un par de preguntas para reservar.",
        "askDistrict": "¿En qué distrito está el piso?",
        "askAddress": "Escribe la dirección: calle, número y piso.",
        "askDay": "¿Cuándo te viene bien? Elige un día.",
        "askTime": "Elige la hora el {{day}}:",
        "dayFull": "Ese día ya está completo. Elige otro día.",
        "noSlots": "No hay horas libres en los próximos días: un operador te contactará para encontrar una."
      },
      "cmdBalance": "Saldo de bariki",
      "cmdHistory": "Historial de bariki",
      "points": {
        "balance": "🪙 Bariki: {{balance}} (≈ {{balance}} ֏)",
        "pending": "⏳ Pendientes: {{pending}}, disponibles desde el {{date}}",
        "burn": "🔥 Caducan el {{date}} si no hay pedidos",
        "empty": "Aún no hay movimientos de bariki.",
        "open": "Abrir bariki",
        "type": {
          "accrual": "Cashback",
          "bonus": "Bono",
          "redemption": "Pago con bariki",
          "request": "Solicitud de pago",
          "reversal": "Anulación"
        },
        "status": {
          "PENDING": "pendiente",
          "ACTIVE": "disponible",
          "SPENT": "gastado",
          "EXPIRED": "caducado",
          "REVERSED": "anulado",
          "REQUESTED": "pendiente de confirmación",
          "CONFIRMED": "canjeado",
          "REJECTED": "rechazado",
          "ACCRUAL": "abono anulado",
          "REDEMPTION": "bariki devueltos"
        }
      }
    },
    "pro": {
      "notLinked": "Este bot es para los especialistas de Barev Club. Pide al operador un enlace de invitación.",
      "linkedProvider": "¡Listo, {{name}}! Tu cuenta está vinculada.",
      "linkedDispatcher": "¡Listo! Eres el despachador de «{{name}}».",
      "youAreProvider": "{{name}} · {{role}}",
      "youAreDispatcher": "Despachador de «{{company}}»",
      "welcome": "Aquí llegan los pedidos nuevos. Acéptalos con los botones del mensaje y gestiona tu día en el panel.",
      "openCabinet": "Abrir panel",
      "messageReceived": "Lo pasamos al operador: la respuesta llegará aquí.",
      "openWeb": "💻 Abrir en el ordenador",
      "webLink": "Enlace al panel para el navegador (un solo uso, válido 15 minutos):\n{{url}}"
    },
    "admin": {
      "hello": "{{name}}, aquí llegan las notificaciones del panel de Barev Club.",
      "linked": "¡Listo, {{name}}! Las notificaciones llegarán aquí. Responde con el botón «Responder».",
      "linkInvalid": "El enlace caducó: pulsa de nuevo «Conectar Telegram» en el panel.",
      "notAdmin": "Este Telegram no está conectado al panel.",
      "open": "Abrir en el panel",
      "reply": "Responder",
      "replyPrompt": "Respuesta para {{name}}: escribe un mensaje. /cancel para cancelar.",
      "replyPlaceholder": "Texto de la respuesta",
      "replySent": "Enviado: {{name}}",
      "replyCancelled": "Respuesta cancelada.",
      "provider": "profesional",
      "newOrder": "Pedido nuevo #{{number}}",
      "newLead": "Solicitud de mudanza n.º {{number}}",
      "newRequest": "Solicitud de la app n.º {{number}}",
      "newWebRequest": "Solicitud de la web n.º {{number}}",
      "loginOk": "Inicio de sesión confirmado: vuelve al navegador.",
      "loginExpired": "El enlace de acceso ha caducado: recarga la página de administración.",
      "channelSupport": "Soporte",
      "channelConcierge": "Conserje",
      "file": "archivo",
      "chatAssigned": "{{by}} te ha pasado una conversación: {{name}}",
      "order": "Pedido n.º {{number}}",
      "noOrder": "Sin pedido en curso",
      "autoFailed": "No hay profesional libre para el pedido n.º {{number}}: asígnalo manualmente.",
      "partnerDeclined": "El socio «{{partner}}» rechazó el pedido n.º {{number}}: reasígnalo",
      "partnerExpired": "El socio «{{partner}}» no asignó personal al pedido n.º {{number}} a tiempo: reasígnalo",
      "noTime": "sin hora",
      "noAddress": "sin dirección",
      "points": {
        "forOrder": "Order #{{number}} for {{sum}}",
        "confirm": "✅ Confirm",
        "reject": "Decline",
        "request": "Client asks to pay with bariki: {{amount}}",
        "balance": "balance {{balance}}",
        "suggestions": "New bariki suggestions: {{count}} ({{open}} in the queue)",
        "overLimit": "{{by}} wants to process {{amount}} bariki — above the limit, needs your approval",
        "mismatch": "Bariki reconciliation: {{count}} clients had a mismatched balance — fixed, check the log",
        "confirmed": "Redeemed {{amount}} bariki",
        "rejected": "Request declined",
        "help": "Credit for an order: /barik <phone or @username> <order amount> [category]\nCategories: cleaning, documents, learning, repair, transfer",
        "noClient": "Client not found",
        "preview": "Credit {{amount}} bariki to {{name}} for {{what}} {{sum}} ֏ ({{tier}}, {{rate}}%). Available from {{date}}.",
        "accrue": "🪙 Credit",
        "done": "Credited {{amount}} bariki",
        "needsApproval": "Above the limit — sent to a super admin for approval",
        "zero": "The amount is 0 — nothing to credit"
      },
      "pay": {
        "subscription": "Membresía {{plan}}",
        "order": "Pedido #{{number}} · {{service}}",
        "paid": "Pago en línea",
        "renewed": "Renovación de membresía",
        "refunded": "Reembolso de pago en línea",
        "cancelled": "Renovación automática detenida",
        "attention": "El pago requiere atención",
        "attentionHint": "El cliente pagó en línea, pero el pedido ya estaba pagado o cancelado — reembólsalo en Tribute.",
        "fromSite": "Pagado en la web (Telegram aún sin vincular)"
      }
    },
    "partner": {
      "valid": "{{name}} — {{level}}, tarjeta válida",
      "until": "suscripción hasta el {{date}}",
      "needLevel": "requiere {{level}}",
      "noOffers": "Aún no hay ofertas: escribe al operador del club.",
      "notPartner": "Es una tarjeta de Barev Club. Solo los socios del club pueden comprobarla.",
      "redeem": "Canjear",
      "redeemed": "Canjeado",
      "redeemedText": "Canjeado: {{offer}}",
      "linkedOwner": "¡Listo! Eres el propietario de «{{partner}}». Abre el panel: ofertas, equipo y escáner QR.",
      "linkedStaff": "¡Listo! Eres del equipo de «{{partner}}». Escanea el QR de los clientes con la cámara o en el panel.",
      "youAreOwner": "Propietario de «{{partner}}»",
      "youAreStaff": "Equipo de «{{partner}}»",
      "left_ONCE": "primera visita",
      "left_WEEK": "quedan esta semana: {{count}}",
      "left_MONTH": "quedan este mes: {{count}}",
      "used_ONCE": "ya usado",
      "used_WEEK": "ya usado esta semana",
      "used_MONTH": "ya usado este mes"
    }
  },
  "notify": {
    "openOrder": "Abrir pedido",
    "duration": "{{minutes}} min",
    "clientLanguage": "Idioma del cliente",
    "created": "Pedido recibido: {{when}}. Total {{total}}. Te avisaremos cuando asignemos un especialista.",
    "rescheduled": "Pedido cambiado al {{when}}.",
    "reminder24": "Recordatorio: mañana, {{when}}.",
    "reminder1": "Dentro de una hora: {{when}}.",
    "event": {
      "arrived": "Tu especialista ha llegado.",
      "openLesson": "Tu clase empieza enseguida.",
      "openMeeting": "Tu reunión empieza enseguida."
    },
    "status": {
      "CLEANING": {
        "NEW": "Buscamos otra persona de limpieza para el {{when}}.",
        "ASSIGNED": "{{provider}} se encargará de la limpieza el {{when}}.",
        "EN_ROUTE": "{{provider}} ya va de camino.",
        "CLEANING": "La limpieza ha empezado.",
        "DONE": "Limpieza terminada. El reporte con fotos está en la app.",
        "CANCELLED": "Pedido cancelado."
      },
      "REPAIR": {
        "NEW": "Buscamos un técnico para el {{when}}.",
        "ASSIGNED": "El técnico {{provider}} irá el {{when}}.",
        "ON_SITE": "El técnico está en el lugar y prepara el presupuesto.",
        "ESTIMATE_APPROVED": "Presupuesto aprobado.",
        "REPAIRING": "La reparación ha empezado.",
        "DONE": "Reparación terminada.",
        "CANCELLED": "Pedido cancelado."
      },
      "TRANSFER": {
        "NEW": "Buscamos conductor para el {{when}}.",
        "ASSIGNED": "El conductor {{provider}} irá el {{when}}.",
        "DRIVER_WAITING": "Tu conductor te espera.",
        "RIDE_IN_PROGRESS": "El viaje ha empezado.",
        "COMPLETED": "Viaje completado.",
        "CANCELLED": "Pedido cancelado."
      },
      "LANGUAGE": {
        "ENROLLED": "Te has inscrito en el curso.",
        "LESSON_SCHEDULED": "Clase programada: {{when}}.",
        "LESSON_IN_PROGRESS": "La clase ha empezado.",
        "LESSON_DONE": "Clase terminada.",
        "COMPLETED": "¡Paquete de clases completado!",
        "CANCELLED": "Pedido cancelado."
      },
      "CAREER": {
        "NEW": "Buscamos un asesor.",
        "CONSULTANT_ASSIGNED": "Asesor asignado: {{provider}}.",
        "RESUME_RECEIVED": "CV recibido.",
        "MEETING": "La reunión ha empezado.",
        "PLAN_SENT": "Tu plan de búsqueda de empleo está listo.",
        "CANCELLED": "Pedido cancelado."
      },
      "DOCUMENTS": {
        "NEW": "Solicitud recibida.",
        "DOCS_REVIEW": "Estamos revisando tus documentos.",
        "NEEDS_MORE_DOCS": "Faltan documentos: los detalles están en la app.",
        "SUBMITTED": "Documentos presentados.",
        "DONE": "¡Tu documento está listo!",
        "CANCELLED": "Pedido cancelado."
      }
    },
    "pro": {
      "offerTitle": "Un pedido nuevo para ti",
      "offerTimeout": "Responde en {{minutes}} min o el pedido pasará a otro especialista.",
      "assignedByDispatcher": "El despachador te asignó un pedido para el {{when}}.",
      "cancelled": "Se canceló el pedido del {{when}}.",
      "rescheduled": "Pedido cambiado al {{when}}.",
      "unassigned": "Se te retiró el pedido del {{when}}.",
      "reminder24": "Pedido mañana: {{when}}.",
      "reminder1": "Pedido dentro de una hora: {{when}}.",
      "orderEdited": "El pedido del {{when}} se actualizó: ábrelo."
    },
    "dispatcher": {
      "newOrder": "Nuevo pedido para la empresa el {{when}}. Asigna a alguien en el panel.",
      "returned": "Alguien del equipo rechazó el pedido del {{when}}. Asigna a otra persona.",
      "noStaff": "No hay personal libre para el pedido del {{when}}: asígnalo a mano en el panel.",
      "expired": "El pedido del {{when}} volvió a Barev Club: no se asignó a nadie a tiempo."
    },
    "openPlan": "Abrir la app",
    "concierge": "Conserje de Barev Club",
    "subscriptionActivated": "{{plan}} activo hasta el {{date}}. Los descuentos ya están en los precios.",
    "operator": "Operador de Barev Club",
    "support": "Soporte de Barev Club",
    "rateAsk": "¿Qué tal fue? Valóralo, por favor, es un segundo:",
    "points": {
      "open": "Mis bariki",
      "pending": "🪙 +{{amount}} bariki por {{what}} del {{date}}. Disponibles desde el {{available}}.",
      "active": "🪙 +{{amount}} bariki por {{what}}. Saldo: {{balance}}.",
      "bonus": "🎁 +{{amount}} bariki de regalo: {{what}}. Válidos hasta el {{until}}.",
      "bonusNoTtl": "🎁 +{{amount}} bariki de regalo: {{what}}.",
      "housewarming": "por la mudanza, de {{agency}}",
      "activated": "✅ {{amount}} bariki ya disponibles. Saldo: {{balance}}.",
      "redeemed": "Pagado con bariki: {{amount}}. A pagar: {{due}}. Saldo: {{balance}}.",
      "redeemedNoOrder": "Bariki canjeados: {{amount}}. Saldo: {{balance}}.",
      "requestExpired": "Tu solicitud de pago con bariki caducó. Envía otra si la necesitas.",
      "rejected": "Tu solicitud de pago con bariki fue rechazada: {{reason}}",
      "declinedGeneric": "escríbenos en el chat y lo vemos.",
      "orderCancelled": "el pedido se canceló",
      "returned": "↩️ {{amount}} bariki han vuelto a tu saldo. Saldo: {{balance}}.",
      "reversed": "El abono {{what}} se anuló: {{reason}}. Saldo: {{balance}}.",
      "expiring": "⏰ {{amount}} bariki caducan en {{days}} días. Cualquier pedido los conserva.",
      "expired": "{{amount}} bariki caducaron por no tener pedidos.",
      "orderEdited": "el pedido cambió: abonaremos el nuevo importe"
    },
    "orderEdited": "Tu pedido se actualizó. Total a pagar: {{total}}."
  },
  "admin": {
    "nav": {
      "orders": "Pedidos",
      "clients": "Clientes",
      "providers": "Especialistas",
      "companies": "Socios de servicios",
      "services": "Servicios y precios",
      "agencies": "Agencias inmobiliarias",
      "settings": "Ajustes",
      "presets": "Tarifas",
      "webRequests": "Solicitudes web",
      "leads": "Mudanzas",
      "concierge": "Conserje",
      "requests": "Solicitudes de la app",
      "partners": "Socios del club",
      "telegram": "Notificaciones",
      "templates": "Plantillas de mudanza"
    },
    "roles": {
      "OWNER": "Propietario",
      "OPERATOR": "Operador"
    },
    "logout": "Cerrar sesión",
    "save": "Guardar",
    "saved": "Guardado",
    "edit": "Editar",
    "add": "Añadir",
    "active": "Activo",
    "copy": "Copiar",
    "copied": "Copiado",
    "login": {
      "title": "Acceso al panel",
      "email": "Usuario o email",
      "password": "Contraseña",
      "submit": "Entrar",
      "totpTitle": "Código de verificación",
      "setupTitle": "Configurar 2FA",
      "setupText": "Escanea el código QR con una app de autenticación (Google Authenticator, 1Password) e introduce el código.",
      "qrAlt": "Código QR para la app de autenticación",
      "code": "Código de la app",
      "verify": "Verificar"
    },
    "summary": {
      "ordersToday": "Pedidos hoy",
      "unassigned": "Sin asignar",
      "revenueToday": "Ingresos de hoy",
      "freeProviders": "Libres / en turno"
    },
    "kanban": {
      "title": "Pedidos",
      "category": "Categoría",
      "allCategories": "Todas las categorías",
      "service": "Servicio",
      "allServices": "Todos los servicios",
      "date": "Fecha",
      "search": "Buscar: n.º, nombre, dirección",
      "showCancelled": "Cancelados",
      "newOrderTitle": "Nuevo pedido",
      "awaiting": "Esperando respuesta: {{name}}",
      "toCompany": "Asignado a empresa: {{name}}",
      "col": {
        "new": "Nuevos",
        "assigned": "Asignados",
        "in_progress": "En curso",
        "done": "Listos",
        "cancelled": "Cancelados"
      }
    },
    "order": {
      "when": "Cuándo",
      "min": "min",
      "params": "Detalles",
      "address": "Dirección",
      "note": "Nota",
      "client": "Cliente",
      "agency": "agencia",
      "provider": "Especialista",
      "price": "Precio",
      "cancelFee": "retención",
      "payment": "Pago",
      "actions": "Acciones",
      "comment": "Comentario de la acción",
      "unassign": "Quitar especialista",
      "confirmUnassign": "¿Quitar al especialista? El pedido vuelve a «Nuevos».",
      "markPaid": "Marcar como pagado",
      "confirmPaid": "¿Marcar {{amount}} como recibido?",
      "cancel": "Cancelar pedido",
      "confirmCancel": "¿Cancelar el pedido? Se avisará al cliente.",
      "checklist": "Lista de control",
      "photo": "Foto",
      "history": "Historial",
      "offers": "Ofertas",
      "assignTitle": "Asignación",
      "assignTo": "Asignar: {{name}}",
      "assign": "Asignar",
      "company": "empresa",
      "noCandidates": "No hay especialistas libres a esa hora.",
      "chooseManually": "Elegir manualmente ({{count}})",
      "hideOthers": "Ocultar",
      "busy": "Ocupados",
      "load_one": "{{count}} pedido ese día",
      "load_few": "{{count}} pedidos ese día",
      "load_many": "{{count}} pedidos ese día",
      "load_other": "{{count}} pedidos ese día",
      "offered": "Pedido enviado al especialista",
      "statusChanged": "Estado cambiado",
      "cancelled": "Pedido cancelado",
      "unassigned": "Especialista retirado",
      "paid": "Pago registrado"
    },
    "reasons": {
      "language": "idioma del cliente",
      "district": "distrito",
      "onShift": "en turno",
      "lowLoad": "día libre"
    },
    "actors": {
      "CLIENT": "cliente",
      "PROVIDER": "especialista",
      "DISPATCHER": "despachador",
      "ADMIN": "operador",
      "SYSTEM": "sistema"
    },
    "offerStatus": {
      "OFFERED": "esperando respuesta",
      "ACCEPTED": "aceptada",
      "DECLINED": "rechazada",
      "EXPIRED": "caducada",
      "REVOKED": "retirada"
    },
    "events": {
      "accepted": "El especialista aceptó",
      "dispatcherAssigned": "El despachador asignó a alguien",
      "assignedToCompany": "Pasado a la empresa",
      "offerDeclined": "El especialista rechazó",
      "offerExpired": "Se agotó el tiempo de respuesta",
      "rescheduled": "Reprogramado",
      "unassigned": "Especialista retirado",
      "depart": "En camino",
      "arrived": "Ha llegado",
      "startCleaning": "Empezó la limpieza",
      "finishCleaning": "Terminó la limpieza",
      "startWork": "Empezó el trabajo",
      "closeRepair": "Cerró el pedido",
      "atPickup": "Conductor en el punto de recogida",
      "passengerIn": "Pasajero a bordo",
      "finishRide": "Viaje terminado",
      "scheduleLesson": "Clase programada",
      "openLesson": "Clase abierta",
      "startLesson": "Clase empezada",
      "finishLesson": "Clase terminada",
      "openMeeting": "Reunión abierta",
      "startMeeting": "Reunión empezada",
      "finishMeeting": "Reunión terminada",
      "editedByStaff": "El equipo cambió el pedido",
      "checklistByStaff": "El equipo marcó un punto",
      "checklistUncheckedByStaff": "El equipo desmarcó un punto"
    },
    "weekdays": {
      "0": "Lun",
      "1": "Mar",
      "2": "Mié",
      "3": "Jue",
      "4": "Vie",
      "5": "Sáb",
      "6": "Dom"
    },
    "schedule": {
      "from": "Desde",
      "to": "Hasta",
      "works": "Día laborable"
    },
    "rate": {
      "PERCENT": "% del pedido",
      "FIXED": "Fijo por pedido"
    },
    "providers": {
      "add": "Añadir especialista",
      "name": "Nombre",
      "phone": "Teléfono",
      "role": "Rol",
      "company": "Empresa",
      "freelancer": "Autónomo",
      "languages": "Idiomas",
      "districts": "Distritos",
      "rate": "Tarifa",
      "rateType": "Tipo de tarifa",
      "ratePercent": "Porcentaje del pedido",
      "rateFixed": "Importe por pedido, ֏",
      "companyRate": "tarifa de la empresa",
      "rating": "Valoración",
      "schedule": "Horario",
      "telegram": "Telegram",
      "linked": "vinculado",
      "resetInvite": "Nuevo enlace de invitación",
      "preset": "Tarifa",
      "ownRate": "Tarifa individual"
    },
    "companies": {
      "add": "Añadir empresa",
      "name": "Nombre",
      "phone": "Teléfono de contacto",
      "roles": "Tipos de pedido",
      "employees": "Equipo",
      "dispatchers": "Despachadores",
      "dispatcherInvite": "Enlace para el despachador"
    },
    "services": {
      "plusDiscount": "Descuento Barev+",
      "active": "disponible",
      "inactive": "oculto",
      "availableToOrder": "Disponible para pedir",
      "prices": "Precios y duración",
      "variant": "Variante",
      "base": "Precio por 1 habitación, ֏",
      "perRoom": "Cada habitación extra, ֏",
      "baseMinutes": "Minutos por 1 habitación",
      "perRoomMinutes": "Minutos por habitación extra",
      "price": "Precio, ֏",
      "minutes": "Duración, min",
      "lateFee": "Retención por cancelación tardía, %",
      "step": "Intervalo de horas, min",
      "dayStart": "Inicio del día, h",
      "dayEnd": "Fin del día, h",
      "leadHours": "Mínimo de horas de antelación",
      "horizon": "Días reservables por adelantado",
      "perBathroom": "Cada baño adicional, ֏",
      "perBathroomMinutes": "Minutos por baño",
      "extras": "Servicios adicionales",
      "extra": "Servicio",
      "extraPrice": "Precio, ֏",
      "extraMinutes": "Minutos por unidad",
      "eliteDiscount": "Descuento Elite"
    },
    "agencies": {
      "add": "Añadir agencia inmobiliaria",
      "name": "Nombre",
      "code": "Código",
      "commission": "Comisión, %",
      "contact": "Contacto",
      "leads": "Leads",
      "links": "Enlaces para QR",
      "bot": "Directo al bot",
      "landing": "A través de la web",
      "hint": "El cliente queda vinculado a la agencia durante {{months}} meses desde su primera visita. La comisión solo cuenta sobre pedidos pagados."
    },
    "clients": {
      "name": "Cliente",
      "language": "Idioma",
      "source": "Origen",
      "membership": "Membresía",
      "orders": "Pedidos",
      "since": "Desde",
      "noConsent": "sin consentimiento",
      "source_organic": "Orgánico",
      "source_deeplink": "Enlace de agencia",
      "source_manual_code": "Código manual",
      "grant": "+30 días de Barev+",
      "grantConfirm": "¿Dar a este cliente 30 días de Barev+?",
      "grantElite": "Elite 30 días",
      "grantEliteConfirm": "¿Dar Barev Elite a este cliente durante 30 días?",
      "segment_MOVING": "se muda",
      "segment_LIVING": "vive en Armenia"
    },
    "settings": {
      "cancel_freeHours": "Cancelación gratis hasta, h antes",
      "agency_attributionMonths": "Cliente vinculado a la agencia, meses",
      "agency_defaultCommissionPct": "Comisión de agencia por defecto, %",
      "barevPlus_giftDays": "Landing: «primeros N días gratis» (el regalo se fija en cada agencia)",
      "barevPlus_monthlyPrice": "Precio mensual de Barev+, ֏",
      "offer_acceptTimeoutMinutes": "Tiempo de respuesta del especialista, min",
      "chat_closeAfterHours": "El chat se cierra tras el pedido, h",
      "files_retentionDays": "Conservar escaneos de documentos, días",
      "consent_version": "Versión de la política de privacidad",
      "paymentMethods": "Métodos de pago",
      "code": "Código",
      "name": "Nombre",
      "admins": "Administradores",
      "role": "Rol",
      "tempPassword": "Contraseña temporal (10+ caracteres)",
      "addAdmin": "Añadir administrador",
      "disable": "Desactivar",
      "enable": "Activar",
      "barevPlus_maxDiscountPct": "Barev+: descuento hasta, %",
      "elite_monthlyPrice": "Barev Elite: precio al mes, ֏",
      "elite_maxDiscountPct": "Barev Elite: descuento hasta, %",
      "relocation_hotelWithPlus": "Inicio: hotel con Barev+, ֏/noche",
      "relocation_hotelBase": "Inicio: hotel sin suscripción, ֏/noche",
      "relocation_consultation": "Inicio: consulta de mudanza, ֏",
      "docs_fromPrice": "/live: documentos «desde», ֏",
      "docs_socialCardPrice": "Tarjeta social completa, AMD",
      "residence_escortFrom": "Residencia: acompañamiento desde, AMD",
      "residence_stateFee": "Residencia: tasa estatal (1 año), AMD",
      "transfer_standardPrice": "Traslado «Estándar», AMD",
      "transfer_premiumPrice": "Traslado «Premium», AMD",
      "assign_auto": "Asignar pedidos automáticamente",
      "assign_maxAutoOffers": "Cuántos profesionales probar automáticamente",
      "sales_bonusPerVenue": "Bono de ventas por local, ֏",
      "sales_bonusPerAgency": "Bono de ventas por agencia, ֏",
      "sales_bonusAgencyPct": "Bono de ventas: % de ingresos de clientes de sus agencias",
      "sales_bonusAgencyMonths": "…durante cuántos meses tras unirse la agencia",
      "partner_fotPct": "Socios (gastos nuestros): nómina del limpiador, % del pedido",
      "partner_taxPct": "Socios (gastos nuestros): impuesto, %",
      "partner_minTravelGapMinutes": "Socios: pausa mínima entre pedidos de un empleado, min",
      "partner_acceptTimeoutMinutes": "Socios: minutos para asignar personal antes de que el pedido vuelva",
      "points_pendingHours": "Bariki: disponibles N horas después del servicio",
      "points_maxSharePct": "Bariki: hasta el N% del pedido",
      "points_minRedeem": "Bariki: mínimo por canje",
      "points_burnDays": "Bariki: caducan tras N días sin actividad",
      "points_warnDays1": "Bariki: primer aviso N días antes",
      "points_warnDays2": "Bariki: segundo aviso N días antes",
      "points_requestTtlHours": "Bariki: la solicitud espera N horas",
      "points_streakGapDays": "Bariki: racha de limpiezas — pausa de hasta N días",
      "points_diffHighlightPct": "Bariki: resaltar importes manuales con más de N% de diferencia",
      "points_supportCanManage": "Soporte también puede abonar y canjear bariki (con límites)",
      "points_opMaxPerOperation": "Límite de soporte por operación, bariki",
      "points_opMaxPerDay": "Límite diario de soporte, bariki",
      "barevPlus_monthlyPriceEur": "Barev+: precio mensual para pago en línea, €",
      "elite_monthlyPriceEur": "Barev Elite: precio mensual para pago en línea, €",
      "fx_eurAmd": "Tipo de cambio: ֏ por 1 € (pedidos en euros)",
      "fx_eurRub": "Tipo de cambio: ₽ por 1 € (indicación «≈ ₽»)"
    },
    "presets": {
      "add": "Añadir plantilla",
      "hint": "La plantilla fija el pago del limpiador por cada línea del precio: importe fijo en AMD o porcentaje. El porcentaje se calcula sobre el precio antes del descuento Barev+. Asígnala en la ficha del especialista.",
      "providers_one": "{{count}} especialista",
      "providers_few": "{{count}} especialistas",
      "providers_many": "{{count}} especialistas",
      "providers_other": "{{count}} especialistas",
      "room": "Cada habitación adicional",
      "bathroom": "Cada baño adicional",
      "name": "Nombre de la plantilla",
      "applyAll": "Un porcentaje para todo",
      "line": "Línea del precio",
      "type": "Tipo",
      "value": "Valor",
      "percent": "% de la línea",
      "fixed": "Fijo {{unit}}",
      "perOrder": "por pedido",
      "perRoom": "por habitación",
      "perBathroom": "por baño"
    },
    "webRequests": {
      "all": "Todas",
      "status_NEW": "No abrió el bot",
      "status_LINKED": "Hay que llamar",
      "status_ORDERED": "Pedido creado",
      "status_CANCELLED": "Cancelada",
      "number": "N.º",
      "when": "Hora preferida",
      "what": "Limpieza",
      "contact": "Contacto",
      "address": "Dirección",
      "price": "Precio",
      "status": "Estado",
      "note": "Nota del operador",
      "notePlaceholder": "Hablamos, volver a llamar…",
      "saveNote": "Guardar",
      "cancel": "Cancelar",
      "cancelConfirm": "¿Cancelar la solicitud n.º {{number}}?",
      "reopen": "Reabrir",
      "order": "Pedido n.º {{number}}",
      "created": "Creada {{date}}",
      "empty": "Aún no hay solicitudes. Aparecerán aquí en cuanto alguien rellene el formulario en barevclub.com/clean."
    },
    "leads": {
      "title": "Solicitudes de mudanza",
      "all": "Todas",
      "empty": "Aún no hay solicitudes del cuestionario.",
      "number": "N.º",
      "contact": "Contacto",
      "plan": "Cuándo",
      "package": "Paquete",
      "status": "Estado",
      "note": "Nota",
      "created": "creada {{date}}",
      "unfinished": "no terminó el cuestionario",
      "moved": "ya vive en Armenia",
      "status_NEW": "Nueva",
      "status_IN_WORK": "En curso",
      "status_DONE": "Hecha",
      "status_CANCELLED": "Cancelada",
      "budget": "{{from}}–{{to}} ֏/noche",
      "inApp": "en la app",
      "stepNote": "Nota para el cliente",
      "stepsInApp": "Plan de mudanza: el cliente ve los pasos en la app y recibe un mensaje en cada cambio",
      "stepsNoApp": "Plan de mudanza: el cliente aún no ha abierto la app",
      "addStep": "Añadir paso",
      "addDoc": "Añadir documento",
      "custom": "Elemento propio…",
      "customPlaceholder": "Nombre para este cliente",
      "docsTitle": "Documentos del cliente: {{done}} de {{total}} listos",
      "remove": "Quitar para este cliente",
      "removeStepConfirm": "¿Quitar el paso «{{name}}» del plan del cliente?"
    },
    "concierge": {
      "empty": "Aún no hay mensajes. Los clientes escriben al bot y la conversación aparece aquí.",
      "placeholder": "La respuesta llega al chat del cliente con el bot. ⌘+Enter para enviar",
      "replyLang": "idioma del cliente: {{lang}}",
      "send": "Enviar",
      "you": "Tú",
      "client": "cliente",
      "provider": "profesional",
      "startHint": "Aún no hay mensajes: escribe primero, llegará al chat con el bot.",
      "write": "Escribir",
      "tab_all": "Todos",
      "tab_clients": "Clientes",
      "tab_providers": "Profesionales"
    },
    "partners": {
      "name": "Nombre",
      "category": "Categoría",
      "offer": "Oferta con tarjeta",
      "address": "Dirección",
      "summary": "ofertas: {{offers}} · equipo: {{members}} · comprobaciones: {{visits}}",
      "manage": "Ofertas y equipo",
      "offers": "Ofertas por nivel",
      "offerTitle": "Oferta",
      "minLevel": "Para quién",
      "allMembers": "Todos los socios",
      "limit": "Con qué frecuencia",
      "limitCount": "Cuántas veces",
      "limitKind_NONE": "Sin límite",
      "limitKind_ONCE": "Solo la primera visita",
      "limitKind_WEEK": "N veces por semana",
      "limitKind_MONTH": "N veces al mes",
      "limit_NONE": "sin límite",
      "limit_ONCE": "solo la primera visita",
      "limit_WEEK": "{{count}}× por semana",
      "limit_MONTH": "{{count}}× al mes",
      "noOffers": "Sin ofertas: los clientes solo verán la descripción.",
      "team": "Propietario y equipo",
      "ownerLink": "Enlace para el propietario",
      "ownerLinkHint": "Envíalo al propietario o deja que lo escanee: se abre el bot, tras Start será propietario y podrá invitar al equipo. De un solo uso.",
      "noTeam": "Aún no hay nadie conectado.",
      "removeConfirm": "¿Desconectar a esta persona del socio?"
    },
    "requests": {
      "activate": "Activar 30 días",
      "activateConfirm": "¿Activar {{plan}} durante 30 días?",
      "client": "Cliente",
      "comment": "Comentario",
      "empty": "No hay solicitudes.",
      "markDone": "Contactado",
      "subscription": "Suscripción {{plan}}",
      "what": "Solicitud",
      "status_NEW": "Nueva",
      "status_DONE": "Hecha",
      "status_CANCELLED": "Cancelada"
    },
    "telegram": {
      "title": "Telegram: @{{bot}}",
      "linked": "conectado",
      "notLinked": "no conectado",
      "what": "El bot de trabajo te envía:",
      "e1": "mensajes de clientes y profesionales: responde en Telegram con el botón «Responder»",
      "e2": "solicitudes de mudanza: de la web y de la app",
      "e3": "solicitudes de la app: suscripciones y llamadas",
      "e4": "pedidos nuevos y solicitudes de limpieza de la web",
      "how": "Pulsa «Conectar»: se abre el bot de trabajo, pulsa «Start». Cada operador se conecta igual con su acceso.",
      "connect": "Conectar Telegram",
      "relink": "Conectar otro Telegram",
      "unlink": "Desconectar",
      "notify": "Enviar notificaciones"
    },
    "templates": {
      "STEP": "Pasos de la mudanza",
      "STEP_hint": "Con ellos se arma el plan: «llave en mano» toma los marcados; el constructor, los elegidos en el cuestionario",
      "DOC": "Documentos",
      "DOC_hint": "La lista que recibe cada cliente nuevo",
      "sub": "Los cambios valen para clientes nuevos. Los pasos y documentos de un cliente concreto se editan en «Mudanzas».",
      "name": "Nombre",
      "hintField": "Pista",
      "active": "Mostrar a clientes nuevos",
      "inTurnkey": "Incluido en «llave en mano»",
      "turnkey": "llave en mano",
      "hidden": "oculto",
      "missing": "falta traducción: {{langs}}"
    }
  },
  "landing": {
    "meta": {
      "title": "Barev Club — Ereván como en casa. Desde el primer día",
      "description": "Limpieza, documentos, formación y descuentos de socios para quienes se mudaron a Ereván. Todo en Telegram, en 5 idiomas."
    },
    "nav": {
      "label": "Secciones",
      "services": "Servicios",
      "how": "Cómo funciona",
      "plans": "Membresía",
      "faq": "Preguntas"
    },
    "openTelegram": "Abrir en Telegram",
    "hero": {
      "tag": "Para quienes se mudaron a Ereván",
      "title": "Ereván como en casa. Desde el primer día.",
      "sub": "Servicios del hogar, documentos, formación y descuentos de socios: un club en Telegram.",
      "cta": "Únete gratis",
      "services": "Ver servicios",
      "cleanTitle": "Limpieza de apartamento desde {{price}}",
      "cleanText": "Calcula el precio y elige la hora en un minuto, sin llamadas.",
      "cleanCta": "Calcular la limpieza"
    },
    "preview": {
      "title": "Mis pedidos",
      "inApp": "en la app",
      "cleaning": "Limpieza · a fondo",
      "cleaningMeta": "Sáb 16:00",
      "inWork": "En curso",
      "lesson": "Armenio A1 · clase 3",
      "lessonMeta": "Hoy 15:00 · en línea",
      "today": "Hoy",
      "cleaningRegular": "Limpieza · regular",
      "cleaningRegularMeta": "Hoy 12:30"
    },
    "languages": "idiomas",
    "noInstall": "Sin instalar nada",
    "noInstallSub": "Todo dentro de Telegram",
    "dir": {
      "HOME": "Especialistas verificados y estado del pedido en la app.",
      "HOME_cta": "Reservar",
      "DOCS": "Traducción notarial y acompañamiento hasta tener el documento.",
      "DOCS_cta": "Tramitar",
      "LEARNING": "En línea y presencial, a la hora que te venga bien.",
      "LEARNING_cta": "Apuntarse",
      "soonCta": "Avísame del lanzamiento"
    },
    "perks": {
      "upTo": "hasta −{{pct}}%",
      "cafes": "Cafeterías",
      "restaurants": "Restaurantes",
      "gifts": "Regalos de socios",
      "text": "Muestra tu tarjeta del club en Telegram al pagar.",
      "cta": "Ver socios"
    },
    "how": {
      "titleBold": "Cómo",
      "titleItalic": "funciona",
      "step1": "Escanea el QR",
      "step1_sub": "Del contrato de alquiler o de la web",
      "step2": "Elige idioma",
      "step2_sub": "Cinco idiomas a elegir",
      "step3": "Reserva un servicio",
      "step3_sub": "Hora, dirección, pago",
      "step4": "Sigue el estado",
      "step4_sub": "Chat con el especialista incluido"
    },
    "agency": {
      "title": "¿Alquilaste con una agencia inmobiliaria asociada?",
      "text": "El código para un mes de Barev+ ya está en tu contrato.",
      "gift": "¡Regalo!",
      "giftSub": "1 mes de Barev+"
    },
    "plans": {
      "tryPlus": "Probar Barev+"
    },
    "faq": {
      "install": {
        "q": "¿Tengo que instalar algo?",
        "a": "No. El club funciona dentro de Telegram: abres el bot y listo."
      },
      "languages": {
        "q": "¿En qué idiomas puedo comunicarme?",
        "a": "Ruso, inglés, chino, armenio y español."
      },
      "plus": {
        "q": "¿En qué se diferencia Barev+ del plan gratuito?",
        "a": "Descuentos de hasta el {{pct}}% en documentos, hogar, formación y asesoría de carrera."
      },
      "gift": {
        "q": "¿Cómo consigo el regalo de la agencia inmobiliaria?",
        "a": "El código está en tu contrato de alquiler. Introdúcelo en el bot y tendrás {{days}} días de Barev+."
      }
    },
    "footer": {
      "brand": "Barev Club · Ereván",
      "partner": "Hazte socio",
      "privacy": "Política de privacidad",
      "legal": "Empresario individual Yuri Zabudko · NIF (ՀՎՀՀ) {{tin}}",
      "services": "Servicios",
      "pricing": "Precios",
      "terms": "Condiciones de uso",
      "refund": "Cancelación y reembolso",
      "rules": "Normas del servicio"
    },
    "clean": {
      "meta": {
        "title": "Limpieza de apartamentos en Ereván — Barev Club",
        "description": "Limpieza regular, a fondo y después de obra. Precio al instante, eliges la hora y sigues el pedido en Telegram."
      },
      "home": "Inicio",
      "title": "Limpieza de apartamentos en Ereván",
      "sub": "Calcula el precio y elige la hora. Confirmamos la solicitud en Telegram y enviamos a la limpiadora.",
      "duration": "Unas {{hours}} h de trabajo",
      "extrasTitle": "Añadir a la limpieza",
      "extrasHint": "Todo lo que haga falta además de la limpieza estándar.",
      "whenTitle": "Cuándo venir",
      "whenHint": "Es la hora que prefieres; la exacta la confirmamos en Telegram.",
      "noTimes": "Ya no quedan horas para este día; mira el siguiente.",
      "addressTitle": "Dirección",
      "district": "Distrito",
      "districtPlaceholder": "Elige un distrito",
      "street": "Calle, número, apartamento",
      "streetPlaceholder": "Por ejemplo, Pushkin 10, apto. 5",
      "note": "Comentario para la limpiadora",
      "notePlaceholder": "Código del portero, mascotas, dónde están las llaves",
      "contactTitle": "Contacto",
      "phone": "Teléfono",
      "phoneHint": "Solo llamamos si no podemos contactarte por Telegram.",
      "name": "Cómo te llamas",
      "consent": "Acepto el tratamiento de mis datos personales",
      "privacy": "Política de privacidad",
      "summaryTitle": "Tu limpieza",
      "total": "Total",
      "plusHint": "Con Barev+: {{pct}}% de descuento en limpieza",
      "submit": "Enviar solicitud",
      "sending": "Enviando…",
      "after": "Al enviarla se abre Telegram: allí confirmamos la hora y mostramos el estado.",
      "err": {
        "time": "Elige una hora.",
        "district": "Elige un distrito.",
        "street": "Indica la calle y el número.",
        "phone": "Indica el teléfono con el código del país, por ejemplo +374 91 123456.",
        "consent": "Sin tu consentimiento no podemos aceptar la solicitud.",
        "network": "No se pudo enviar. Revisa la conexión e inténtalo de nuevo."
      },
      "doneTitle": "Solicitud n.º {{number}} recibida",
      "doneText": "Se está abriendo Telegram: el bot confirmará la solicitud y mostrará su estado. Si no pasa nada, pulsa el botón.",
      "doneCta": "Abrir Telegram",
      "doneAgain": "Hacer otra solicitud",
      "includedTitle": "Qué incluye",
      "zone": {
        "kitchen": "Cocina",
        "bathroom": "Baño",
        "rooms": "Habitaciones"
      },
      "inc": {
        "kitchen": "Limpiamos el fregadero y el grifo\nLimpiamos la cocina, la encimera y el frente\nLimpiamos los frentes de los armarios y los electrodomésticos por fuera\nFregamos el suelo y sacamos la basura",
        "bathroom": "Limpiamos la bañera o la ducha, el lavabo y el inodoro\nLimpiamos espejos y grifos\nLimpiamos estantes y puertas\nFregamos el suelo",
        "rooms": "Quitamos el polvo de las superficies accesibles\nAspiramos y fregamos el suelo\nHacemos la cama y ordenamos\nLimpiamos espejos e interruptores"
      },
      "general": "A fondo: todo esto más los lugares de difícil acceso: detrás de los muebles, zócalos, puertas, radiadores y dentro de los armarios.",
      "renovation": "Después de obra: además, polvo de construcción y restos de pintura, cola y cemento en todas las superficies.",
      "howTitle": "Cómo funciona",
      "how1": "Dejas la solicitud aquí",
      "how1Sub": "Ves el precio al instante, sin llamadas",
      "how2": "Confirmamos en Telegram",
      "how2Sub": "El bot muestra el pedido y su estado",
      "how3": "Llega la limpiadora",
      "how3Sub": "Trabaja con una lista y envía un informe con fotos",
      "whenHintOptional": "Opcional: si lo omites, el bot te lo preguntará en Telegram.",
      "addressHintOptional": "Opcional: puedes enviar la dirección al bot después.",
      "nameTitle": "Cómo te llamas",
      "consentByClick": "Al pulsar el botón, aceptas el tratamiento de tus datos personales."
    },
    "v1": {
      "title": "Todo para vivir en Ereván, en un solo chat",
      "sub": "Barev Club es un bot de Telegram. Dices lo que necesitas, ves el precio al instante y eliges la hora. Del resto nos ocupamos nosotros.",
      "botName": "Barev Club",
      "botStatus": "bot, responde al instante",
      "u1": "¡Hola! Necesito una limpieza el sábado, 2 habitaciones",
      "b1": "¡Hola! Limpieza regular, 2 habitaciones y un baño: {{price}}. ¿Te va bien el sábado a las 11:00?",
      "u2": "Sí, perfecto",
      "b2": "Listo. La limpiadora llega a las 11:00; te enviaré aquí el estado y el informe con fotos.",
      "canTitle": "Qué puedes pedir",
      "canText": "La limpieza ya funciona. El resto lo lanzamos poco a poco; el bot te avisará cuando abra.",
      "whyTitle": "Por qué en Telegram",
      "why1": "No hay que instalar nada",
      "why1Sub": "El bot y la app se abren dentro de Telegram.",
      "why2": "Cinco idiomas",
      "why2Sub": "Ruso, inglés, chino, armenio y español.",
      "why3": "Todo en una conversación",
      "why3Sub": "Estado, chat con el profesional e informe con fotos, donde ya hablas.",
      "ctaTitle": "Empieza con «Barev»",
      "ctaText": "Así se dice «hola» en armenio. Escribe al bot: te responde en tu idioma.",
      "cta": "Escribir al bot"
    },
    "v2": {
      "hello": "Привет\nHello\n你好\nԲարև\nHola",
      "title": "Mudarte a Ereván, paso a paso",
      "sub": "Del aeropuerto a tu propio piso y tus documentos. El club está contigo en cada paso, y cualquier duda se resuelve en un solo chat.",
      "calc": "Calcular",
      "ctaTitle": "El club es gratis",
      "ctaText": "Únete en Telegram: todos los pasos a mano, en tu idioma.",
      "cta": "Unirme al club",
      "whenArrive": "Llegada",
      "whenWeek": "Primera semana",
      "whenSettled": "Tras instalarte",
      "whenLater": "Después",
      "whenDaily": "Cada día",
      "whenAnytime": "En cualquier momento",
      "airportTitle": "Te recibimos en el aeropuerto y te alojamos en un hotel",
      "airportText": "Un conductor con un cartel en Zvartnots y traslado al hotel: los primeros días sin preocupaciones.",
      "flatTitle": "Encontramos tu piso",
      "flatText": "Buscamos vivienda con agencias inmobiliarias asociadas y la limpiamos antes de que entres.",
      "docsTitle": "Hacemos el registro y la tarjeta social",
      "docsText": "Preparamos los documentos, pedimos la cita y te acompañamos hasta la tarjeta lista.",
      "permitTitle": "Te ayudamos con los documentos de residencia",
      "permitText": "Reunimos el expediente, lo traducimos y legalizamos, y te explicamos plazos y cómo presentarlo.",
      "perksTitle": "Disfruta de los descuentos y ventajas del club",
      "perksText": "Cafeterías, restaurantes y regalos de socios con la tarjeta del club; con Barev+, también descuentos en servicios.",
      "chatTitle": "Cualquier duda, al chat",
      "chatText": "Se rompió un grifo o te pasaste del plazo de estancia en Armenia: escribe «¡ayuda!», lo resolvemos y te decimos qué hacer.",
      "chatChip": "en Telegram",
      "chatCta": "Escribir al chat"
    },
    "v3": {
      "tag": "Para inquilinos de agencias inmobiliarias asociadas",
      "title": "Bienvenido a casa",
      "sub": "La agencia inmobiliaria con la que alquilaste te regala una suscripción a Barev+: descuentos en limpieza, documentos y clases.",
      "giftTitle": "1 mes de Barev+",
      "giftCode": "El código {{code}} se aplica solo",
      "giftNoCode": "El código está en tu contrato de alquiler",
      "stepsTitle": "Cómo conseguirlo",
      "step1": "Pulsa «Recibir el regalo»",
      "step1Sub": "Se abre el bot de Barev Club en Telegram.",
      "step2": "Elige idioma y confirma el consentimiento",
      "step2Sub": "Son diez segundos.",
      "step3": "El regalo se activa solo",
      "step3Sub": "Los descuentos se aplican enseguida a tus pedidos.",
      "benefitsTitle": "Qué te da un mes de Barev+",
      "cleaningDeal": "Limpieza desde {{price}} en vez de {{full}}",
      "cleaningDealSub": "Limpieza regular, con el descuento ya incluido.",
      "cta": "Recibir el regalo",
      "noCode": "¿Sin código? Envíalo al bot con /code, o únete sin él: el club es gratis."
    },
    "v4": {
      "title": "¿Acabas de llegar a Ereván? Ahora nos toca a nosotros",
      "sub": "Limpieza, documentos y clases de armenio: lo pides en Telegram en tu idioma, como si llevaras años aquí.",
      "board": "Llegadas",
      "city": "Ereván",
      "colFlight": "Vuelo",
      "colService": "Servicio",
      "colPrice": "Precio",
      "colStatus": "Estado",
      "live": "Abierto",
      "soon": "Pronto",
      "passTitle": "Tarjeta de embarque",
      "passenger": "Pasajero",
      "passengerValue": "Tú",
      "from": "Desde",
      "fromValue": "Cualquier lugar",
      "to": "Hacia",
      "toValue": "Ereván, como en casa",
      "gate": "Puerta",
      "gateValue": "Telegram",
      "cta": "Embarcar",
      "clean": "Pedir una limpieza ya"
    },
    "v5": {
      "title": "Cuánto ahorras con Barev+",
      "sub": "Un cálculo honesto: el precio de la suscripción ya está restado del ahorro.",
      "perMonth": "Limpiezas al mes",
      "without": "Sin Barev+",
      "with": "Con Barev+",
      "withNote": "incluida la suscripción de {{price}}",
      "save": "Ahorro al mes",
      "noSave": "Por ahora sale más barato sin suscripción",
      "breakeven": "Barev+ compensa a partir de {{count}} limpiezas de este tamaño al mes.",
      "breakevenFirst": "Barev+ compensa desde la primera limpieza de este tamaño.",
      "perYear": "Al año: {{amount}}",
      "other": "La suscripción también sirve para otras categorías",
      "cta": "Probar Barev+",
      "gift": "¿Alquilaste con una agencia inmobiliaria asociada? La suscripción es un regalo."
    },
    "v6": {
      "tag": "Para agencias inmobiliarias",
      "title": "Un acuerdo sobre cómo tus inquilinos se instalan en Ereván",
      "sub": "Regalas a tus clientes un mes de Barev+, nosotros les ayudamos con el día a día y tú recibes un porcentaje de sus pedidos.",
      "docDate": "Ereván",
      "s1": "Qué recibe la agencia inmobiliaria",
      "s1i1": "El {{pct}}% de cada pedido del cliente durante {{months}} meses desde su primera visita al bot.",
      "s1i2": "Tu propio código y QR: añádelos al contrato o entrégalos con las llaves.",
      "s1i3": "Un informe de clientes y pedidos: cuántos llegaron, cuántos pidieron y cuánto ganaste.",
      "s2": "Qué recibe el inquilino",
      "s2i1": "{{days}} días de Barev+ de regalo: descuentos en limpieza, documentos y clases.",
      "s2i2": "Un servicio en cinco idiomas dentro de Telegram, sin apps ni llamadas.",
      "s2i3": "Profesionales verificados y el estado de cada pedido.",
      "s3": "Cómo unirse",
      "s3i1": "Escríbenos en el bot: respondemos en un día.",
      "s3i2": "Recibe el código de la agencia y el QR.",
      "s3i3": "Añade el QR al contrato de alquiler. Del resto nos encargamos nosotros.",
      "exampleTitle": "Ejemplo",
      "exampleText": "{{clients}} clientes × {{orders}} limpiezas al mes × {{price}}",
      "exampleResult": "{{amount}} para la agencia al mes",
      "exampleNote": "Cálculo con una limpieza regular de un piso de dos habitaciones.",
      "signAgency": "Agencia inmobiliaria",
      "signUs": "Barev Club",
      "cta": "Hacerme socio"
    },
    "home": {
      "metaTitle": "Mudarse a Armenia: vivienda, tarjeta social, residencia — Barev Club",
      "metaDescription": "Te recibimos en el aeropuerto Zvartnots, buscamos piso en Ereván, tarjeta social en 1 día, empadronamiento y trámites de residencia. Un chat de Telegram en 5 idiomas.",
      "switchLabel": "Para quién es esta página",
      "switchMove": "Me mudo",
      "switchLive": "Ya vivo en Armenia",
      "title": "Mudarse a Armenia, paso a paso",
      "sub": "Te recogemos en el aeropuerto, buscamos piso y hacemos los trámites. Todas las dudas, en un solo chat y en tu idioma.",
      "cta": "Planificar mi mudanza",
      "ctaChat": "Escribir por Telegram",
      "whenArrive": "Llegada",
      "whenFirst": "Primeros días",
      "whenSettled": "Ya instalado",
      "whenLater": "Más adelante",
      "whenDaily": "Cada día",
      "whenAnytime": "En cualquier momento",
      "airportTitle": "Recogida en el aeropuerto y hotel",
      "airportText": "Un conductor con cartel en Zvartnots, el traslado y una habitación de hotel: los primeros días sin preocupaciones.",
      "flatTitle": "Te buscamos piso",
      "flatText": "Opciones en 1 día y visitas al día siguiente.",
      "docsTitle": "Empadronamiento y tarjeta social",
      "docsText": "Preparamos los documentos y te acompañamos hasta tener la tarjeta. Tarjeta social, al día siguiente.",
      "permitTitle": "Trámites del permiso de residencia",
      "permitText": "Por contrato de trabajo: reunimos el expediente, traducimos y legalizamos, y te explicamos los plazos.",
      "perksTitle": "Descuentos y ventajas del club",
      "perksText": "Descuentos en servicios y regalos de socios con Barev+ y Barev Elite.",
      "chatTitle": "Cualquier duda, al chat",
      "chatText": "Se rompió un grifo o te pasaste del plazo de estancia: escribe «¡ayuda!», lo resolvemos y te decimos qué hacer.",
      "chatCta": "Abrir el chat",
      "finalTitle": "Cuéntanos tu mudanza",
      "finalText": "Unas pocas preguntas y te preparamos un plan de mudanza con precio.",
      "more": "Más detalles",
      "perksSoon": "Próximamente"
    },
    "live": {
      "metaTitle": "Descuentos en servicios en Ereván con suscripción — Barev Club",
      "metaDescription": "Suscripción del club: hasta −{{pct}}% en limpieza, reparaciones, traslados, excursiones y trámites, idiomas y asesoría profesional, regalos de socios.",
      "title": "¿Vives en Armenia? Con el club, más barato",
      "sub": "Suscríbete y consigue descuentos en los servicios que necesitas cada mes.",
      "cta": "Suscribirme",
      "ctaPlans": "Comparar planes",
      "listTitle": "En qué se aplican los descuentos",
      "listNote": "El descuento máximo es con Barev Elite. Con Barev+, hasta −{{pct}}%.",
      "upTo": "hasta −{{pct}}%",
      "discount": "descuento",
      "gifts": "regalos",
      "cleaning": "Limpieza",
      "cleaningHint": "regular, a fondo, tras una reforma",
      "repair": "Reparaciones",
      "repairHint": "fontanero, electricista, arreglos pequeños",
      "transfer": "Traslados",
      "transferHint": "desde y hacia el aeropuerto",
      "tours": "Excursiones",
      "toursHint": "Garni, Geghard, Sevan y más",
      "docs": "Trámites",
      "docsHint": "tarjeta social, residencia, empadronamiento, alta de autónomo y SL",
      "lang": "Idiomas",
      "langHint": "inglés y armenio",
      "career": "Carrera",
      "careerHint": "CV, perfil de LinkedIn, preparación de entrevistas",
      "partners": "Socios",
      "partnersHint": "cafés, restaurantes y tiendas del club",
      "finalTitle": "La suscripción se hace en Telegram",
      "finalText": "Abre el bot del club y elige un plan: los descuentos aparecen en los precios.",
      "orderNow": "Reservar ahora",
      "docsFrom": "desde {{price}} con suscripción"
    },
    "club": {
      "title": "Suscripción del club",
      "sub": "Pedir servicios es gratis. Los descuentos y el conserje van con la suscripción.",
      "free": "gratis",
      "perMonth": "{{price}}/mes",
      "freeF1": "Pedidos y estados en el bot de Telegram",
      "freeF2": "Pago y chat para cada solicitud",
      "freeF3": "Precios normales de los servicios",
      "plusF1": "Hasta −{{pct}}% en servicios",
      "plusF2": "Regalos de socios",
      "plusF3": "Conserje en el chat de lunes a viernes, de 10 a 18",
      "eliteF1": "Hasta −{{pct}}% en servicios",
      "eliteF2": "Regalos de socios",
      "eliteF3": "Conserje en el chat 24/7: resolvemos cualquier tema",
      "freeCta": "Abrir el bot",
      "plusCta": "Contratar Barev+",
      "eliteCta": "Contratar Elite"
    },
    "quiz": {
      "dialog": "Planificar la mudanza",
      "close": "Cerrar",
      "back": "Atrás",
      "next": "Siguiente",
      "progress": "Paso {{n}} de {{total}}",
      "sending": "Guardando…",
      "contactTitle": "¿Cómo te llamas?",
      "name": "Nombre",
      "contact": "Teléfono o Telegram",
      "contactHint": "+374 … o @usuario",
      "consentPre": "Al pulsar «Siguiente» aceptas la ",
      "consentLink": "política de privacidad",
      "errName": "Dinos cómo llamarte.",
      "errContact": "Necesitamos un teléfono (+374…) o un usuario de Telegram (@usuario).",
      "movedTitle": "¿Ya te has mudado a Armenia?",
      "movedYes": "Sí, ya vivo aquí",
      "movedNo": "No, lo estoy planeando",
      "movingToLive": "Abriendo la página para quienes ya viven en Armenia…",
      "whenTitle": "¿Cuándo piensas mudarte?",
      "when_month": "En el próximo mes",
      "when_quarter": "En 1–3 meses",
      "when_later": "Más adelante, todavía mirando",
      "when_date": "Sé la fecha exacta",
      "date": "Fecha de llegada",
      "errWhen": "Elige una opción o indica la fecha.",
      "packageTitle": "¿Qué paquete necesitas?",
      "package_CONSULT": "Solo consulta",
      "package_CONSULT_text": "Estudiamos tu caso y preparamos un plan de mudanza.",
      "package_TURNKEY": "Llave en mano",
      "package_TURNKEY_text": "Desde la recogida en el aeropuerto hasta la residencia o el empadronamiento. Calculamos el precio exacto.",
      "package_TURNKEY_price": "a presupuesto",
      "package_CUSTOM": "Lo armo yo",
      "package_CUSTOM_text": "Marca solo los servicios que necesitas.",
      "customTitle": "Arma tu paquete",
      "airport": "Recogida en el aeropuerto",
      "airport_none": "No hace falta",
      "airport_standard": "Estándar",
      "airport_premium": "Premium",
      "stay": "Alojamiento para empezar",
      "stay_none": "No hace falta",
      "stay_flat": "Piso",
      "stay_hotel": "Hotel",
      "budget": "Presupuesto por noche, ֏",
      "budgetFrom": "desde",
      "budgetTo": "hasta",
      "flat": "Búsqueda de piso",
      "socialCard": "Tarjeta social",
      "bankCard": "Tarjeta bancaria",
      "registration": "Empadronamiento",
      "residence": "Permiso de residencia",
      "no": "No",
      "yes": "Sí",
      "yesHint": "Te contactaremos para concretar",
      "errEmpty": "Marca al menos un servicio.",
      "submit": "Enviar solicitud",
      "doneTitle": "Solicitud n.º {{number}} recibida",
      "doneText": "Te contactaremos en un día: {{contact}}.",
      "doneBot": "Abrir el club en Telegram",
      "doneClose": "Volver a la web",
      "errNetwork": "No hay conexión con el servidor. Revisa internet e inténtalo de nuevo."
    },
    "seo": {
      "org": "Barev Club es un club de servicios para quienes se mudan a Ereván o ya viven en Armenia: recogida en el aeropuerto, vivienda, tarjeta social, residencia, limpieza y descuentos de socios. Todo en Telegram, en 5 idiomas."
    },
    "svc": {
      "common": {
        "home": "Inicio",
        "updated": "Actualizado el 20 de octubre de 2026",
        "factsTitle": "En resumen",
        "pricesTitle": "Precios",
        "faqTitle": "Preguntas frecuentes",
        "relatedTitle": "Más sobre la mudanza",
        "cta": "Escríbenos en Telegram",
        "ctaMove": "Mudanza completa",
        "clean": "Limpieza del piso",
        "breadcrumbs": "Navegación"
      },
      "socialCard": {
        "meta": {
          "title": "Tarjeta social en Armenia para extranjeros: documentos, plazos y precio — Barev Club",
          "description": "Cómo obtener la tarjeta social (Número de Servicios Públicos, ՀԾՀ) en Armenia en 2026: documentos, dónde ir y cuánto se tarda. Lo hacemos todo por {{price}}, normalmente en 1 día."
        },
        "crumb": "Tarjeta social",
        "h1": "Tarjeta social en Armenia: consíguela en 1 día",
        "lead": "La tarjeta social es tu Número de Servicios Públicos (ՀԾՀ), de 10 cifras. Sin él no puedes abrir una cuenta bancaria, darte de alta como autónomo ni pedir la residencia en Armenia. Los extranjeros lo obtienen en una oficina del Servicio de Migración, normalmente el mismo día. Barev Club lo gestiona todo por {{price}}: traducción del pasaporte, cita y acompañamiento.",
        "priceLabel": "Todo incluido",
        "priceValue": "{{price}}",
        "priceNote": "traducción del pasaporte, notario, cita y acompañamiento",
        "facts": {
          "f1": {
            "label": "Plazo",
            "value": "normalmente 1 día"
          },
          "f2": {
            "label": "Precio",
            "value": "{{price}} todo incluido"
          },
          "f3": {
            "label": "Dónde se emite",
            "value": "oficina del Servicio de Migración"
          },
          "f4": {
            "label": "Qué necesitas",
            "value": "pasaporte con sello de entrada"
          }
        },
        "stepsTitle": "Cómo lo hacemos",
        "steps": {
          "s1": {
            "when": "Día 1",
            "title": "Nos escribes por Telegram",
            "text": "Envías una foto del pasaporte y tu dirección en Ereván. Sirve la de un piso alquilado o un hotel."
          },
          "s2": {
            "when": "Día 1",
            "title": "Traducción notarial",
            "text": "Traducimos la página principal del pasaporte al armenio y la certificamos ante notario."
          },
          "s3": {
            "when": "Día 1",
            "title": "Pedimos cita",
            "text": "Elegimos una oficina con poca cola y la hora que te venga bien."
          },
          "s4": {
            "when": "Día 1–2",
            "title": "Vamos juntos",
            "text": "Tu acompañante habla armenio y rellena la solicitud. Solo tienes que ir con el pasaporte."
          },
          "s5": {
            "when": "Día 1–2",
            "title": "Recibes el número",
            "text": "El certificado con el número suele emitirse en el momento, a veces al día siguiente."
          }
        },
        "blocks": {
          "b1": {
            "title": "Qué es la tarjeta social",
            "body": "«Tarjeta social» es el nombre coloquial del Número de Servicios Públicos (ՀԾՀ, PSN). Es un número único de 10 cifras que el Estado asigna a los ciudadanos armenios y a los extranjeros que están legalmente en el país.\nA los extranjeros no se les da una tarjeta de plástico, sino un certificado con el número. Si ya tienes residencia, el número puede figurar en tu tarjeta de residente."
          },
          "b2": {
            "title": "Para qué sirve",
            "body": "• abrir una cuenta y una tarjeta en un banco armenio;\n• darte de alta como autónomo o crear una sociedad;\n• pagar impuestos y cobrar un salario oficial;\n• solicitar la residencia;\n• pedir cita en un centro de salud público;\n• comprar un coche y obtener el carné de conducir armenio."
          },
          "b3": {
            "title": "Documentos necesarios",
            "body": "• Pasaporte con sello de entrada en Armenia.\n• Traducción notarial al armenio de la página principal del pasaporte: la hacemos nosotros.\n• Una dirección en Armenia: sirve un piso alquilado o un hotel, sin empadronamiento.\n• Si entraste con el pasaporte interno ruso, también su traducción notarial. Puede añadir unos días.\nA veces la oficina pide el certificado de nacimiento o un justificante de registro. Si hace falta, te avisaremos antes."
          },
          "b4": {
            "title": "Qué cambia el 1 de noviembre de 2026",
            "body": "El 1 de noviembre de 2026 entra en vigor la nueva Ley de Extranjería de Armenia y cambia el sistema de citas del Servicio de Migración. Seguimos los cambios y te daremos cita según las normas vigentes."
          }
        },
        "prices": {
          "p1": {
            "name": "Tarjeta social todo incluido",
            "value": "{{price}}",
            "note": "traducción, notario, cita, acompañamiento"
          },
          "p2": {
            "name": "Con Barev+",
            "value": "−{{docsPct}}%",
            "note": "en todos los servicios de documentos"
          }
        },
        "faq": {
          "q1": {
            "q": "¿Se puede obtener la tarjeta social sin residencia?",
            "a": "Sí. El número se emite a extranjeros que están legalmente en Armenia, por ejemplo con el sello de entrada. No hace falta tener residencia."
          },
          "q2": {
            "q": "¿Cuánto se tarda en obtener la tarjeta social?",
            "a": "La mayoría de oficinas emiten el certificado el mismo día; algunas, al día siguiente. Preparamos antes la traducción notarial del pasaporte, así que todo suele llevar 1–2 días."
          },
          "q3": {
            "q": "¿Hace falta hablar armenio?",
            "a": "No. Te acompaña una persona que habla armenio e inglés o ruso y rellena la solicitud por ti."
          },
          "q4": {
            "q": "¿Se puede obtener sin ir en persona?",
            "a": "Un representante con poder notarial puede recoger el certificado y, con firma electrónica armenia, se puede hacer en línea. Si no estás en Ereván, escríbenos y buscaremos una solución."
          },
          "q5": {
            "q": "¿En qué se diferencia la tarjeta social del número fiscal (ՀՎՀՀ)?",
            "a": "La tarjeta social (ՀԾՀ) es un número personal. El ՀՎՀՀ es el número fiscal que reciben autónomos y empresas. Para darte de alta como autónomo primero necesitas la tarjeta social."
          }
        },
        "finalTitle": "¿Necesitas la tarjeta social?",
        "finalText": "Escríbenos por Telegram: te damos cita para el primer día que te venga bien y traducimos tu pasaporte."
      },
      "residence": {
        "meta": {
          "title": "Residencia en Armenia 2026: nuevas normas desde el 1 de noviembre, motivos y precio — Barev Club",
          "description": "Cómo obtener la residencia en Armenia con la nueva ley: trabajo, autónomo, sociedad, familia. Tasa {{fee}}, solicitud en línea. Consulta {{consult}}, acompañamiento desde {{escort}}."
        },
        "crumb": "Residencia",
        "h1": "Residencia en Armenia en 2026: qué ha cambiado y cómo obtenerla",
        "lead": "Desde el 1 de noviembre de 2026 se aplica la nueva Ley de Extranjería de Armenia. La residencia se solicita en línea, primero se concede por 1 año y la tasa estatal sube a {{fee}}. Los motivos son trabajo, autónomo, sociedad, estudios o familia. Barev Club te ayuda a elegir el motivo y te acompaña hasta que tengas la tarjeta de residente.",
        "priceLabel": "Acompañamiento",
        "priceValue": "desde {{escort}}",
        "priceNote": "+ tasa {{fee}}. La consulta de {{consult}} se descuenta",
        "facts": {
          "f1": {
            "label": "Nuevas normas",
            "value": "desde el 1 de noviembre de 2026"
          },
          "f2": {
            "label": "Tasa estatal",
            "value": "{{fee}} por 1 año"
          },
          "f3": {
            "label": "Solicitud",
            "value": "en línea + una visita para huellas"
          },
          "f4": {
            "label": "Acompañamiento",
            "value": "desde {{escort}}"
          }
        },
        "stepsTitle": "Cómo tramitamos tu residencia",
        "steps": {
          "s1": {
            "when": "Semana 1",
            "title": "Consulta",
            "text": "Analizamos tu caso y elegimos el motivo: trabajo, autónomo, sociedad o familia. La consulta de {{consult}} se descuenta del acompañamiento."
          },
          "s2": {
            "when": "Semana 1–2",
            "title": "Preparamos el motivo",
            "text": "Te ayudamos a darte de alta como autónomo o crear una sociedad, depositar el importe necesario o firmar un contrato de trabajo."
          },
          "s3": {
            "when": "Semana 2–3",
            "title": "Reunimos los documentos",
            "text": "Traducimos y certificamos los documentos y tramitamos la tarjeta social si aún no la tienes."
          },
          "s4": {
            "when": "Solicitud",
            "title": "Presentamos en línea",
            "text": "Rellenamos la solicitud en el portal estatal y respondemos a los requerimientos del Servicio de Migración."
          },
          "s5": {
            "when": "Visita",
            "title": "Das tus huellas",
            "text": "Hay que ir una vez en persona al Servicio de Migración para dar las huellas y firmar. Vamos contigo."
          },
          "s6": {
            "when": "Listo",
            "title": "Recibes la tarjeta de residente",
            "text": "Te informamos de la resolución y te ayudamos a recoger la tarjeta."
          }
        },
        "blocks": {
          "b1": {
            "title": "Qué cambió el 1 de noviembre de 2026",
            "body": "• La reforma de la Ley de Extranjería se aprobó el 20 de enero de 2026 y se aplica desde el 1 de noviembre de 2026.\n• La solicitud se presenta en línea en un portal único. Solo hay que ir una vez en persona para dar las huellas y firmar; un poder notarial no lo sustituye.\n• Primero se concede la residencia por 1 año. La permanente de 5 años exige 3 años de residencia temporal dentro de los últimos 5.\n• La tasa por 1 año es de 150 000 ֏ más 5950 ֏ por la tarjeta; la residencia permanente cuesta 255 950 ֏.\n• El Gobierno introduce cupos anuales. Cuando se agota el cupo, no se admiten nuevas solicitudes.\n• Ya no se concede el estatus especial de 10 años para personas de origen armenio; los documentos emitidos siguen vigentes hasta su vencimiento.\n• Las solicitudes presentadas antes del 1 de noviembre se resuelven con las normas anteriores. Las residencias ya concedidas valen hasta la fecha de la tarjeta; las nuevas normas se aplican al renovar."
          },
          "b2": {
            "title": "Motivos para la residencia",
            "body": "• Trabajo: contrato con una empresa armenia. Se eliminó la prueba del mercado laboral; en su lugar hay un cupo.\n• Autónomo: 1 000 000 ֏ en una cuenta de un banco armenio al presentar la solicitud, o la misma facturación en los 60 días anteriores.\n• Sociedad: aportación al capital o compra de participaciones desde 2 000 000 ֏. Si en 180 días tras la aprobación no hay liquidación de impuestos, la residencia puede anularse.\n• Estudios: no solo universidades, también cursos, formación profesional y programas de intercambio.\n• Familia: cónyuge, padre, madre o hijo de un ciudadano armenio o de un extranjero con residencia.\nComprar un piso no da derecho por sí solo a la residencia."
          },
          "b3": {
            "title": "Documentos que necesitarás",
            "body": "• pasaporte y su traducción notarial al armenio;\n• justificante del motivo: contrato de trabajo, alta de autónomo o de la sociedad, certificado bancario, certificado de matrimonio o de nacimiento;\n• tarjeta social (Número de Servicios Públicos);\n• justificante de pago de la tasa.\nLa lista exacta la fija el Gobierno por reglamento. En la consulta la comprobamos con la versión vigente."
          },
          "b4": {
            "title": "¿Se puede vivir en Armenia sin residencia?",
            "body": "Los ciudadanos rusos entran sin visado y pueden quedarse hasta 180 días por entrada. Para otras nacionalidades rigen sus propias normas. Si se acerca el final del plazo y aún no tienes residencia, la estancia irregular puede acarrear una multa. Escríbenos con tiempo y te diremos qué se puede hacer."
          },
          "b5": {
            "title": "Importante",
            "body": "Información vigente a 20 de octubre de 2026. Parte de las normas se está desarrollando por reglamento, así que antes de cada solicitud comprobamos los requisitos con el Servicio de Migración. Esta página no sustituye el asesoramiento jurídico."
          }
        },
        "prices": {
          "p1": {
            "name": "Consulta",
            "value": "{{consult}}",
            "note": "se descuenta del acompañamiento"
          },
          "p2": {
            "name": "Acompañamiento hasta la tarjeta",
            "value": "desde {{escort}}",
            "note": "motivo, documentos, solicitud, visita"
          },
          "p3": {
            "name": "Tasa estatal, residencia de 1 año",
            "value": "{{fee}}",
            "note": "se paga al Estado, desde el 1 de noviembre de 2026"
          },
          "p4": {
            "name": "Tasa estatal, residencia de 5 años",
            "value": "255 950 ֏",
            "note": "tras 3 años de residencia temporal"
          }
        },
        "faq": {
          "q1": {
            "q": "¿Cuánto cuesta la residencia en Armenia en 2026?",
            "a": "Desde el 1 de noviembre de 2026 la tasa por la residencia de 1 año es de {{fee}}: 150 000 ֏ de tasa más 5950 ֏ por la tarjeta. Como autónomo necesitas además 1 000 000 ֏ en la cuenta o la misma facturación en 60 días. El acompañamiento de Barev Club cuesta desde {{escort}}."
          },
          "q2": {
            "q": "¿Cuánto tarda la resolución?",
            "a": "El Servicio de Migración aún no ha publicado los plazos del nuevo sistema. Te daremos un plazo realista en la consulta cuando lleguen las primeras resoluciones con las nuevas normas."
          },
          "q3": {
            "q": "¿Se puede obtener la residencia en Armenia comprando un piso?",
            "a": "No. Con la nueva ley, ser propietario de un inmueble no da derecho por sí solo a la residencia. Hace falta trabajo, negocio, estudios o vínculos familiares."
          },
          "q4": {
            "q": "¿Tengo que ir en persona?",
            "a": "Sí, una vez: para dar las huellas y firmar la solicitud en Armenia. Un poder notarial no lo sustituye; todo lo demás se hace en línea."
          },
          "q5": {
            "q": "¿Qué pasa con la residencia que ya tengo?",
            "a": "Sigue vigente hasta la fecha de vencimiento de la tarjeta. Al renovar se aplican las nuevas normas, la nueva tasa y la solicitud en línea."
          },
          "q6": {
            "q": "¿Se puede obtener directamente la residencia de 5 años?",
            "a": "Normalmente no: primero se concede por 1 año, y la permanente tras 3 años de residencia temporal en los últimos 5. Las excepciones son las personas de origen armenio, los inversores y quienes tengan méritos especiales ante Armenia."
          }
        },
        "finalTitle": "Analicemos tu caso",
        "finalText": "Cuéntanos tu situación por Telegram: elegiremos el motivo adecuado y calcularemos el coste total."
      },
      "airport": {
        "meta": {
          "title": "Traslado del aeropuerto de Zvartnots a Ereván con recogida — Barev Club",
          "description": "Te recibimos en Zvartnots con un cartel, te ayudamos con el equipaje y te llevamos a tu casa u hotel en Ereván. Estándar {{standard}}, Premium {{premium}}. Seguimiento del vuelo y 60 minutos de espera gratis."
        },
        "crumb": "Traslado del aeropuerto",
        "h1": "Traslado desde el aeropuerto de Zvartnots con recogida",
        "lead": "El conductor te espera en la sala de llegadas del aeropuerto de Zvartnots con un cartel, te ayuda con el equipaje y te lleva a cualquier dirección de Ereván. El trayecto al centro dura 20–30 minutos. El Estándar cuesta {{standard}} por coche hasta 3 pasajeros y el Premium {{premium}}. Seguimos tu vuelo y los primeros 60 minutos de espera son gratis.",
        "priceLabel": "Recogida Estándar",
        "priceValue": "{{standard}}",
        "priceNote": "hasta 3 pasajeros, cartel, 60 minutos de espera",
        "facts": {
          "f1": {
            "label": "Punto de encuentro",
            "value": "sala de llegadas, con cartel"
          },
          "f2": {
            "label": "Al centro",
            "value": "20–30 minutos"
          },
          "f3": {
            "label": "Estándar",
            "value": "{{standard}}"
          },
          "f4": {
            "label": "Premium",
            "value": "{{premium}}"
          }
        },
        "stepsTitle": "Cómo es la recogida",
        "steps": {
          "s1": {
            "when": "Antes del vuelo",
            "title": "Envías el número de vuelo",
            "text": "Escríbenos por Telegram el número de vuelo, los pasajeros, las maletas y la dirección en Ereván."
          },
          "s2": {
            "when": "Antes del vuelo",
            "title": "Recibes los datos del conductor",
            "text": "Te enviamos el nombre del conductor, la matrícula y un chat con él en el bot."
          },
          "s3": {
            "when": "Llegada",
            "title": "Seguimos tu vuelo",
            "text": "Si el vuelo se retrasa, el conductor llega a la nueva hora sin coste extra."
          },
          "s4": {
            "when": "Llegada",
            "title": "Recogida con cartel",
            "text": "El conductor te espera en llegadas con un cartel con tu nombre y te ayuda con el equipaje."
          },
          "s5": {
            "when": "30 minutos después",
            "title": "Has llegado",
            "text": "Te dejamos en tu piso u hotel de Ereván."
          }
        },
        "blocks": {
          "b1": {
            "title": "Qué incluye",
            "body": "• recogida en la sala de llegadas con cartel;\n• ayuda con el equipaje;\n• hasta 3 pasajeros en el Estándar;\n• seguimiento del vuelo;\n• 60 minutos de espera gratis tras el aterrizaje;\n• chat con el conductor a través del bot.\nEl Premium añade un coche de clase business, agua en el coche y una tarjeta SIM armenia para que tengas conexión nada más llegar."
          },
          "b2": {
            "title": "Hotel para los primeros días",
            "body": "Si aún no tienes piso, reservamos un hotel y te llevamos directamente. Con Barev+ desde {{hotelPlus}} por noche; sin suscripción, desde {{hotelBase}}."
          },
          "b3": {
            "title": "Otras formas de salir de Zvartnots",
            "body": "• Taxi del mostrador del aeropuerto: según las guías de viaje, suele costar 3000–7000 ֏ hasta el centro, pero nadie te espera en llegadas.\n• Apps de taxi como Yandex Go: baratas, pero tienes que encontrar el coche en el aparcamiento.\n• El traslado con recogida cuesta más, pero el conductor espera en llegadas, sigue tu vuelo y te ayuda con el equipaje. Es práctico si viajas en familia, llegas tarde o vienes a Armenia por primera vez."
          }
        },
        "prices": {
          "p1": {
            "name": "Estándar",
            "value": "{{standard}}",
            "note": "hasta 3 pasajeros, cartel, 60 minutos de espera"
          },
          "p2": {
            "name": "Premium",
            "value": "{{premium}}",
            "note": "clase business, agua, tarjeta SIM"
          },
          "p3": {
            "name": "Hotel con Barev+",
            "value": "desde {{hotelPlus}}",
            "note": "por noche; sin suscripción, desde {{hotelBase}}"
          },
          "p4": {
            "name": "Con Barev+",
            "value": "−{{homePct}}%",
            "note": "en traslados y servicios del hogar"
          }
        },
        "faq": {
          "q1": {
            "q": "¿Cuánto cuesta el traslado del aeropuerto de Zvartnots al centro de Ereván?",
            "a": "Con Barev Club cuesta {{standard}} por coche hasta 3 pasajeros con recogida y cartel; el Premium, {{premium}}. Un taxi del mostrador del aeropuerto suele costar 3000–7000 ֏, pero sin recogida en llegadas."
          },
          "q2": {
            "q": "¿Qué pasa si mi vuelo se retrasa?",
            "a": "Seguimos tu vuelo y el conductor llega a la hora real de aterrizaje. Los primeros 60 minutos tras el aterrizaje son gratis."
          },
          "q3": {
            "q": "¿Cuánto se tarda del aeropuerto al centro de Ereván?",
            "a": "Unos 20–30 minutos sin tráfico: el aeropuerto de Zvartnots está a unos 12 km al oeste del centro."
          },
          "q4": {
            "q": "¿Puedo reservar un traslado al aeropuerto?",
            "a": "Sí. Te llevamos a Zvartnots desde cualquier dirección de Ereván por el mismo precio."
          },
          "q5": {
            "q": "¿Cómo reservo la recogida?",
            "a": "Escríbenos por Telegram el número de vuelo, los pasajeros y la dirección, idealmente al menos un día antes de aterrizar."
          }
        },
        "finalTitle": "¿Vuelas a Ereván?",
        "finalText": "Envíanos tu número de vuelo por Telegram: te recogemos y te llevamos hasta la puerta."
      }
    },
    "pay": {
      "cardCta": "Pagar con tarjeta",
      "redirecting": "Abriendo el pago…",
      "orTelegram": "o contratar en Telegram",
      "approx": "≈ {{amd}} · ≈ {{rub}}, se cobra en euros, renovación mensual",
      "error": "No se pudo abrir el pago. Inténtalo de nuevo o contrata en Telegram.",
      "metaTitle": "Pago de la membresía — Barev Club",
      "checking": "Comprobando el pago…",
      "pendingTitle": "Esperando la confirmación del pago",
      "pendingText": "Suele tardar unos segundos; la página se actualiza sola.",
      "backToPayment": "Volver al pago",
      "paidTitle": "¡Pago recibido! {{plan}} está listo para activar",
      "paidText": "El club funciona en Telegram. Pulsa el botón: el bot vinculará la membresía a tu cuenta y los descuentos funcionarán al instante.",
      "activate": "Activar en Telegram",
      "renewNote": "La membresía se renueva cada mes por {{price}}. Puedes desactivar la renovación en la app, en «Membresía».",
      "claimedTitle": "{{plan}} está activa",
      "claimedText": "La membresía está vinculada a tu Telegram. Abre el bot: los descuentos ya funcionan.",
      "openBot": "Abrir el bot",
      "failedTitle": "El pago no se completó",
      "failedText": "No se ha cobrado nada. Inténtalo de nuevo o con otra tarjeta.",
      "retry": "Intentar de nuevo",
      "refundedTitle": "Pago reembolsado",
      "notFoundTitle": "Pago no encontrado",
      "notFoundText": "Revisa el enlace o escríbenos: te ayudamos."
    }
  },
  "privacy": {
    "title": "Política de privacidad",
    "updated": "Versión del 22 de octubre de 2026",
    "intro": "Esta política explica qué datos personales recoge Barev Club, para qué, con quién los compartimos y cómo puedes controlarlos. Se aplica al sitio barevclub.com, a los bots de Telegram y a las mini apps de Barev Club.",
    "operator": {
      "title": "Quién trata tus datos",
      "body": "El responsable del tratamiento es el empresario individual Yuri Konstantínovich Zabudko (Ա/Ձ Զաբուդկո Յուրի Կոնստանտինի), República de Armenia, número fiscal (ՀՎՀՀ) {{tin}}. Barev Club es el nombre del servicio.\nPara cuestiones sobre datos, escribe a {{email}}, llama al {{phone}} o escribe en el chat del bot."
    },
    "data": {
      "title": "Qué datos recibimos",
      "body": "• De Telegram: ID, nombre de usuario, nombre y apellido del perfil, idioma. El número de teléfono solo si decides compartirlo.\n• Solicitudes del sitio: nombre, teléfono o usuario de Telegram, tus respuestas en el planificador de mudanza (fechas, servicios, presupuesto). Para la limpieza: dirección, distrito, hora deseada y comentario.\n• Pedidos: dirección y distrito, ubicación en el mapa (si la indicas), opciones del servicio, fecha y hora, precio, descuento, estado del pago, comentarios.\n• Documentos: copias escaneadas del pasaporte y otros documentos que subes para los servicios de Documentos.\n• Mensajes con el especialista a través del bot, informes fotográficos, valoraciones y reseñas.\n• Membresía: nivel (Barev, Barev+, Elite), fechas de suscripción, código de la tarjeta del club y registros de su uso en socios.\n• Origen: la agencia o código promocional con el que llegaste y etiquetas de campañas (UTM).\n• Datos técnicos: una cookie con el idioma del sitio, el código de agencia en el almacenamiento del navegador y registros del servidor (dirección IP, hora y dirección solicitada) para protegernos de fallos y ataques.\nNo recibimos datos de tarjetas bancarias: en los pagos en línea se introducen en la página del servicio de pagos Tribute (tribute.tg)."
    },
    "purposes": {
      "title": "Para qué los usamos",
      "body": "• Tramitar y cumplir tu pedido: asignar un especialista, calcular el precio, informarte del estado.\n• Contactarte sobre tu solicitud y preparar un plan de mudanza.\n• Gestionar tu suscripción, tarjeta del club y descuentos.\n• Calcular la comisión de la agencia que te recomendó y los pagos a los especialistas.\n• Llevar la contabilidad y los registros fiscales.\n• Mejorar el servicio con las valoraciones y reseñas.\n• Enviarte novedades y ofertas del club, salvo que te hayas dado de baja."
    },
    "basis": {
      "title": "Base legal",
      "body": "Tratamos los datos con base en el consentimiento que das en el bot o en un formulario del sitio, para cumplir tu pedido y para cumplir la legislación de la República de Armenia, incluida la Ley de Protección de Datos Personales.\nPuedes retirar tu consentimiento en cualquier momento. Esto no afecta al tratamiento realizado antes de retirarlo."
    },
    "recipients": {
      "title": "Con quién compartimos los datos",
      "body": "No vendemos datos personales y solo compartimos lo que necesita cada tarea:\n• Con el especialista de tu pedido y, si lo realiza una empresa asociada, con su coordinador: nombre, idioma, dirección y detalles del pedido. Tu número de teléfono no se muestra al especialista; la comunicación es a través del bot.\n• Con la agencia inmobiliaria que te recomendó: tu nombre, si usas el club y los importes de los pedidos pagados, para calcular su comisión.\n• Con un socio del club cuando muestras tu tarjeta: tu nombre y nivel de membresía.\n• Con Telegram, donde funcionan los bots y mini apps; Telegram trata los datos según su propia política.\n• Con Hostinger International, en cuyos servidores se guardan la base de datos y los archivos.\n• Con el servicio de pagos Tribute (tribute.tg), que procesa los pagos en línea: email (si lo indicaste), importe, concepto del pago y un número interno de cliente. Tribute trata los datos de la tarjeta por su cuenta según su propia política de privacidad.\n• Con organismos públicos, cuando pides un servicio de documentos y los presentamos en tu nombre, o cuando la ley lo exige."
    },
    "location": {
      "title": "Dónde se guardan los datos",
      "body": "La base de datos y los archivos se guardan en un servidor en Alemania (Fráncfort del Meno, proveedor Hostinger). Alemania forma parte de la Unión Europea, donde se aplica el Reglamento General de Protección de Datos (RGPD).\nAl dar tu consentimiento aceptas la transferencia de datos fuera de Armenia. Telegram puede tratar datos en otros países."
    },
    "retention": {
      "title": "Cuánto tiempo guardamos los datos",
      "body": "• Perfil: mientras uses el servicio o hasta que pidas eliminarlo.\n• Pedidos y pagos: 5 años tras completar el pedido, como exigen las normas contables y fiscales.\n• Mensajes con el especialista e informes fotográficos: 1 año tras completar el pedido.\n• Solicitudes del sitio que no terminaron en pedido: 12 meses.\n• Copias de documentos: 90 días tras completar el pedido; después se eliminan automáticamente.\nAl terminar el plazo, los datos se eliminan o se anonimizan."
    },
    "security": {
      "title": "Cómo protegemos los datos",
      "body": "• El sitio y las apps funcionan solo con HTTPS.\n• Las copias de documentos se guardan cifradas. Solo el operador y el especialista asignado pueden abrirlas, mediante enlaces temporales, y cada acceso queda registrado.\n• El acceso al panel de administración está protegido con contraseña y autenticación de dos factores, y las acciones de los administradores se registran.\n• Hacemos una copia de seguridad de la base de datos cada día."
    },
    "rights": {
      "title": "Tus derechos",
      "body": "Puedes:\n• saber qué datos tenemos sobre ti y obtener una copia;\n• corregir datos inexactos;\n• eliminar tus datos y tu perfil, salvo los que debamos conservar por ley;\n• retirar el consentimiento al tratamiento;\n• darte de baja de novedades y ofertas;\n• presentar una reclamación ante la Agencia de Protección de Datos Personales del Ministerio de Justicia de la República de Armenia.\nEscribe a {{email}} o en el chat del bot. Responderemos en los plazos que fija la legislación de la República de Armenia. Sin consentimiento al tratamiento no podremos aceptar nuevos pedidos."
    },
    "marketing": {
      "title": "Novedades y ofertas",
      "body": "De vez en cuando enviamos en el bot novedades del club, promociones y ofertas de socios. Puedes darte de baja en cualquier momento: escribe «baja» en el chat del bot o a {{email}}.\nLos mensajes sobre pedidos, tu suscripción y recordatorios de citas se envían igualmente."
    },
    "cookies": {
      "title": "Cookies",
      "body": "El sitio usa una sola cookie, barev_lang, con el idioma elegido para abrirse en él la próxima vez. Si llegaste por el enlace de una agencia, su código se guarda en el almacenamiento del navegador para no perder tu descuento. El sitio no usa cookies publicitarias ni analíticas."
    },
    "age": {
      "title": "Edad",
      "body": "El servicio es para mayores de edad. Si tienes menos de 18 años, no nos des tus datos. Los datos de menores, por ejemplo para documentos familiares, los facilita un padre, madre o tutor legal, que es responsable de ellos."
    },
    "changes": {
      "title": "Cambios en la política",
      "body": "Podemos actualizar esta política. La versión vigente está siempre en esta página, con su fecha al principio. Te avisaremos en el bot de los cambios importantes.\nEl texto en ruso es la versión principal; las traducciones se ofrecen por comodidad."
    }
  },
  "pricing": {
    "title": "Precios",
    "updated": "Vigentes desde el 22 de octubre de 2026",
    "intro": "Cuánto cuestan la suscripción a Barev Club y los servicios del club. Puedes pedir servicios sin suscripción: esta solo añade descuentos y un conserje. Todos los precios están en drams armenios (֏).",
    "from": "desde {{price}}",
    "perDay": "{{price}} por noche",
    "plansTitle": "Suscripción al club",
    "plansNote": "La suscripción se paga mensualmente y se renueva hasta que la canceles. Puedes cancelarla en cualquier momento: seguirá activa hasta el final del mes pagado.",
    "planNote": {
      "free": "Registro en el bot de Telegram, sin pago y sin plazo.",
      "plus": "Se contrata en el bot. Si llegas a través de una agencia inmobiliaria asociada, la suscripción es un regalo (normalmente {{days}} días o más; cada agencia fija sus condiciones).",
      "elite": "Se contrata con un operador del club en el chat del bot."
    },
    "servicesTitle": "Servicios",
    "servicesNote": "Estos son los precios base. Antes de que confirmes el pedido, el bot muestra el precio exacto con tus opciones y el descuento de la suscripción. Una vez confirmado, el precio no cambia.",
    "rows": {
      "cleaning": {
        "name": "Limpieza del piso",
        "note": "Depende del tipo de limpieza y del número de habitaciones"
      },
      "transferStandard": {
        "name": "Traslado desde el aeropuerto de Zvartnots, Estándar",
        "note": "Hasta 3 pasajeros, cartel con tu nombre, 60 minutos de espera"
      },
      "transferPremium": {
        "name": "Traslado desde el aeropuerto de Zvartnots, Premium",
        "note": "Clase business, agua, tarjeta SIM"
      },
      "hotel": {
        "name": "Hotel para los primeros días",
        "note": "Precio con Barev+; sin suscripción, desde {{base}} por noche"
      },
      "socialCard": {
        "name": "Tarjeta social, de principio a fin",
        "note": "Traducción del pasaporte, notario, cita, acompañamiento"
      },
      "consultation": {
        "name": "Consulta sobre el permiso de residencia",
        "note": "Se descuenta del precio del acompañamiento"
      },
      "residence": {
        "name": "Acompañamiento del permiso de residencia",
        "note": "Base legal, documentos, solicitud, visita. La tasa estatal de {{fee}} por el permiso de 1 año se paga al Estado por separado"
      }
    },
    "payTitle": "Pago y cancelación",
    "payBody": "Las membresías Barev+ y Elite se pagan con tarjeta en euros en la web o en la app y se renuevan automáticamente cada mes; puedes desactivar la renovación en cualquier momento. Los pagos los procesa Tribute; los pagos de la membresía se reembolsan a petición en un plazo de 14 días. Los pedidos de servicios se pueden pagar en línea en la app (en euros al tipo de cambio) o en efectivo o por transferencia. Puedes cancelar o cambiar la fecha gratis hasta 24 horas antes del inicio del servicio. Los detalles están en las condiciones de uso y en la política de reembolso."
  },
  "terms": {
    "title": "Condiciones de uso",
    "updated": "Versión del 22 de octubre de 2026",
    "intro": "Estas son las condiciones en las que Barev Club presta sus servicios a través de barevclub.com, sus bots de Telegram y sus mini apps. Al hacer un pedido o contratar una suscripción, aceptas estas condiciones.",
    "about": {
      "title": "Quiénes somos y qué hacemos",
      "body": "Barev Club es un servicio para quienes se mudan a Armenia o ya viven aquí: servicios del hogar (limpieza, traslado desde el aeropuerto, hotel para los primeros días), ayuda con documentos (tarjeta social, permiso de residencia), formación y descuentos de los socios del club.\nLos servicios los presta el empresario individual Yuri Konstantinovich Zabudko (Ա/Ձ Զաբուդկո Յուրի Կոնստանտինի), República de Armenia, NIF (ՀՎՀՀ) {{tin}}. Contacto: {{email}}, {{phone}}.\nLos pedidos los realizan proveedores verificados: nuestro personal o empresas socias. Barev Club responde ante ti por el resultado."
    },
    "acceptance": {
      "title": "Aceptación de las condiciones",
      "body": "Las condiciones se aplican desde el momento en que haces un pedido, contratas una suscripción o envías una solicitud en la web o en el bot. Para usar el servicio debes tener 18 años o más.\nSi no estás de acuerdo con las condiciones, no hagas el pedido."
    },
    "orders": {
      "title": "Cómo funciona un pedido",
      "body": "• Eliges un servicio en el bot o envías una solicitud en la web e indicas los detalles: dirección, fecha, hora y demás.\n• Antes de confirmar, el bot muestra el precio total, el descuento y las condiciones de cancelación.\n• El pedido queda aceptado cuando lo confirmas y asignamos un proveedor. Recibes un aviso de esto y de cada estado posterior.\n• Hablas con el proveedor a través del chat del bot.\nSi no podemos realizar el pedido a la hora elegida, te propondremos otra o cancelaremos el pedido sin coste."
    },
    "prices": {
      "title": "Precios",
      "body": "Los precios figuran en drams armenios en la página «Precios» y en el bot. Podemos cambiar los precios, pero el de un pedido ya confirmado no cambia.\nLas tasas y derechos estatales, como la tasa del permiso de residencia, no están incluidos en el precio del servicio salvo que se indique expresamente. Te decimos el importe por adelantado."
    },
    "payment": {
      "title": "Pago",
      "body": "Las membresías Barev+ y Barev Elite se pueden pagar con tarjeta en línea en la web o en la app. La membresía se renueva automáticamente cada mes con la misma tarjeta; puedes desactivar la renovación en cualquier momento en la app («Membresía») o escribiéndonos, y el mes pagado se mantiene. Los pedidos de servicios se pueden pagar en línea en la app: el importe se convierte de drams a euros al tipo indicado antes del pago. Los pagos en línea los procesa el servicio de pagos Tribute (tribute.tg); los datos de la tarjeta se introducen en su página y no los recibimos ni los guardamos.\nLos servicios (limpieza, traslados, documentos y otros) no se venden en línea: se pagan en efectivo o por transferencia al proveedor, o por transferencia a la cuenta de Barev Club; el método se elige en el pedido.\nEmitimos un justificante de pago a petición."
    },
    "cancel": {
      "title": "Cancelación y cambio de fecha",
      "body": "Puedes cancelar o cambiar la fecha de un pedido gratis hasta 24 horas antes del inicio del servicio, en el bot o en el chat con un operador.\nSi cancelas más tarde, se retiene una parte del precio. El importe se indica en la ficha del servicio antes de confirmar el pedido; por defecto es el 30 %.\nSi cancelamos nosotros o el proveedor no se presenta, te devolvemos todo el importe. Más detalles en la política de reembolso."
    },
    "subscription": {
      "title": "Suscripción Barev+ y Barev Elite",
      "body": "• La suscripción da descuentos en los servicios del club, regalos de los socios y un conserje en el chat. Niveles y precios en la página «Precios».\n• La suscripción se paga mensualmente y se renueva automáticamente hasta que la canceles. Te avisamos 3 días antes de la renovación.\n• El descuento se aplica a los pedidos hechos mientras la suscripción está activa.\n• El periodo gratuito con el código de una agencia socia se concede una sola vez por cliente.\n• Puedes cancelarla en cualquier momento en el bot o en el chat con un operador. Seguirá activa hasta el final del periodo pagado."
    },
    "perks": {
      "title": "Descuentos y regalos de los socios",
      "body": "Los descuentos y regalos con la tarjeta del club los ofrecen los socios del club: cafeterías, restaurantes y otras empresas. Las condiciones de cada oferta figuran en el catálogo de socios.\nCada socio responde de sus propios productos y servicios. Las ofertas de los socios pueden cambiar o terminar."
    },
    "docs": {
      "title": "Servicios de documentación",
      "body": "Te ayudamos a reunir los documentos, los traducimos, pedimos cita y te acompañamos a los organismos públicos. La decisión de expedir un documento o un permiso de residencia la toma el organismo público y no podemos garantizarla.\nEres responsable de que los documentos y datos que nos das sean auténticos y exactos. Si una denegación se debe a un error nuestro, lo corregiremos a nuestra costa."
    },
    "client": {
      "title": "Tus obligaciones",
      "body": "• Dar datos correctos: dirección, contacto, opciones del pedido.\n• Dar acceso al piso a la hora acordada y condiciones seguras para el trabajo del proveedor.\n• Tratar con respeto a proveedores y operadores.\n• No usar el servicio con fines ilícitos.\nSi el proveedor no puede empezar por causa tuya (por ejemplo, no hay nadie en la dirección), se considera una cancelación tardía."
    },
    "quality": {
      "title": "Calidad y reclamaciones",
      "body": "Si no quedas satisfecho con el resultado, escribe en el chat del pedido en las 24 horas siguientes y, si puedes, adjunta fotos. Corregiremos los defectos gratis o devolveremos parte o todo el precio.\nSi un proveedor daña tus bienes, avísanos en 24 horas: lo revisaremos y compensaremos el daño confirmado."
    },
    "liability": {
      "title": "Responsabilidad",
      "body": "Nuestra responsabilidad por un pedido se limita a su precio, salvo en caso de daños confirmados a bienes y cuando la ley no permite ese límite.\nNo respondemos de retrasos ni cancelaciones por causas ajenas a nuestro control: decisiones de organismos públicos, retrasos de vuelos, desastres naturales, caídas de Telegram."
    },
    "content": {
      "title": "Contenido de la web",
      "body": "Los textos, el diseño, el logotipo y el nombre Barev Club pertenecen al titular del servicio. No los copies sin permiso."
    },
    "changes": {
      "title": "Cambios en las condiciones",
      "body": "Podemos actualizar estas condiciones. La versión vigente está siempre en esta página, con su fecha al principio. Los pedidos ya confirmados se realizan con las condiciones anteriores. Te avisaremos en el bot con antelación de los cambios importantes en la suscripción."
    },
    "law": {
      "title": "Ley aplicable y disputas",
      "body": "Estas condiciones se rigen por la legislación de la República de Armenia. Primero intentamos resolver las disputas negociando: escribe a {{email}} y responderemos en 3 días hábiles. Si no llegamos a un acuerdo, la disputa la resuelve un tribunal de la República de Armenia.\nEstas condiciones no limitan tus derechos legales como consumidor.\nEl texto original está en ruso; las traducciones se ofrecen por comodidad."
    }
  },
  "refund": {
    "title": "Cancelación y reembolso",
    "updated": "Versión del 22 de octubre de 2026",
    "intro": "Cuándo y cuánto reembolsa Barev Club por los servicios y la suscripción, y cómo solicitar un reembolso.",
    "cancelClient": {
      "title": "Si cancelas tú",
      "body": "• Con 24 horas o más de antelación al inicio del servicio, cancelar y cambiar la fecha es gratis y te devolvemos todo el importe.\n• Con menos de 24 horas, se retiene una parte del precio y se devuelve el resto. El importe se indica en la ficha del servicio antes de confirmar el pedido; por defecto es el 30 %.\n• Una vez iniciado el servicio, no se devuelve la parte ya realizada."
    },
    "cancelUs": {
      "title": "Si cancelamos nosotros",
      "body": "Si cancelamos el pedido, no encontramos proveedor o el proveedor no se presenta, tú eliges: cambiar a otra hora que te venga bien o recibir el reembolso completo."
    },
    "quality": {
      "title": "Si no quedas satisfecho",
      "body": "Escribe en el chat del pedido en las 24 horas siguientes a su realización y, si puedes, adjunta fotos. Corregiremos los defectos gratis y, si no es posible, devolveremos parte o todo el precio según lo que haya fallado."
    },
    "subscription": {
      "title": "Suscripción Barev+ y Barev Elite",
      "body": "• Cualquier pago de la suscripción se devuelve íntegro si lo pides en los 14 días siguientes al cobro.\n• Puedes cancelar en cualquier momento: no se cobrará el siguiente pago y la suscripción seguirá activa hasta el final del mes pagado.\n• El periodo gratuito no cuesta nada, así que no hay nada que reembolsar."
    },
    "nonRefundable": {
      "title": "Qué no se reembolsa",
      "body": "• Las tasas y derechos estatales que ya hemos pagado en tu nombre.\n• Los gastos que ya hemos pagado a terceros por tu pedido: por ejemplo, una traducción notarial o una reserva de hotel según las normas del hotel.\n• Los productos y servicios de los socios del club: se aplican las normas del socio."
    },
    "howTo": {
      "title": "Cómo solicitar un reembolso",
      "body": "Escribe en el chat del bot o a {{email}} indicando el número de pedido o de suscripción y el motivo. Responderemos en 3 días hábiles.\nSi pagaste en línea, el dinero se devuelve a la misma tarjeta a través del servicio de pagos Tribute, normalmente en unos días hábiles tras nuestra confirmación."
    },
    "timing": {
      "title": "Plazos y forma de reembolso",
      "body": "El dinero se devuelve por el mismo medio con el que pagaste, en un plazo de 10 días hábiles desde que se aprueba el reembolso. En tarjeta puede tardar unos días más, según tu banco. Si pagaste en efectivo, te lo devolvemos por transferencia o en efectivo, como prefieras.\nDudas sobre reembolsos: {{email}}, {{phone}}."
    }
  }
}
